import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
};

export type Query = {
  __typename?: 'Query';
  /** Retrieve a single "CacPublicId" node. */
  cacPublicId?: Maybe<CacPublicId>;
  /** Retrieve the number of "CacPublicId" nodes. */
  cacPublicIdCount: Scalars['Int']['output'];
  /** Retrieve a list of "CacPublicId" nodes. */
  cacPublicIds: Array<CacPublicId>;
  /** Retrieve a list of "Category" nodes. */
  categories: Array<Category>;
  /** Retrieve a single "Category" node. */
  category?: Maybe<Category>;
  /** Retrieve the number of "Category" nodes. */
  categoryCount: Scalars['Int']['output'];
  /** Retrieve a single "CategoryUrl" node. */
  categoryUrl?: Maybe<CategoryUrl>;
  /** Retrieve the number of "CategoryUrl" nodes. */
  categoryUrlCount: Scalars['Int']['output'];
  /** Retrieve a list of "CategoryUrl" nodes. */
  categoryUrls: Array<CategoryUrl>;
  /** Retrieve a single "FacPublicId" node. */
  facPublicId?: Maybe<FacPublicId>;
  /** Retrieve the number of "FacPublicId" nodes. */
  facPublicIdCount: Scalars['Int']['output'];
  /** Retrieve a list of "FacPublicId" nodes. */
  facPublicIds: Array<FacPublicId>;
  /** Count active or existing published recipe by brand for authors */
  getAuthorRecipeCount: Array<AuthorRecipeCount>;
  /** Get Main Category for a recipe */
  getMainCategoryAI?: Maybe<MainCategoryAiType>;
  /** Get generate recipe advice with AI */
  getRecipeAdviceAi?: Maybe<RecipeAdviceAiType>;
  /** Get generate recipe advice with AI */
  getRecipeCompleteAi?: Maybe<RecipeCompleteAiType>;
  /** Get generated recipe lead with AI */
  getRecipeLeadAi?: Maybe<RecipeLeadAiType>;
  /** List segmentations by brandKey and TargetDevices */
  getVertexAIRecipes?: Maybe<VertexAiRecipesResultType>;
  /** Retrieve a single "Prompt" node. */
  prompt?: Maybe<Prompt>;
  /** Retrieve the number of "Prompt" nodes. */
  promptCount: Scalars['Int']['output'];
  /** Retrieve a list of "Prompt" nodes. */
  prompts: Array<Prompt>;
  /** Retrieve a single "Recipe" node. */
  recipe?: Maybe<Recipe>;
  /** Retrieve a list of "RecipeCategory" nodes. */
  recipeCategories: Array<RecipeCategory>;
  /** Retrieve a single "RecipeCategory" node. */
  recipeCategory?: Maybe<RecipeCategory>;
  /** Retrieve the number of "RecipeCategory" nodes. */
  recipeCategoryCount: Scalars['Int']['output'];
  /** Retrieve the number of "Recipe" nodes. */
  recipeCount: Scalars['Int']['output'];
  /** Retrieve a single "RecipeGuide" node. */
  recipeGuide?: Maybe<RecipeGuide>;
  /** Retrieve the number of "RecipeGuide" nodes. */
  recipeGuideCount: Scalars['Int']['output'];
  /** Retrieve a list of "RecipeGuide" nodes. */
  recipeGuides: Array<RecipeGuide>;
  /** Retrieve a list of "RecipeHistory" nodes. */
  recipeHistories: Array<RecipeHistory>;
  /** Retrieve a single "RecipeHistory" node. */
  recipeHistory?: Maybe<RecipeHistory>;
  /** Retrieve the number of "RecipeHistory" nodes. */
  recipeHistoryCount: Scalars['Int']['output'];
  /** Retrieve a list of "Recipe" nodes. */
  recipes: Array<Recipe>;
  /** Retrieve a single "RecipeTag" node. */
  recipeTag?: Maybe<RecipeTag>;
  /** Retrieve the number of "RecipeTag" nodes. */
  recipeTagCount: Scalars['Int']['output'];
  /** Retrieve a list of "RecipeTag" nodes. */
  recipeTags: Array<RecipeTag>;
  /** Retrieve a single "RecipeUrl" node. */
  recipeUrl?: Maybe<RecipeUrl>;
  /** Retrieve the number of "RecipeUrl" nodes. */
  recipeUrlCount: Scalars['Int']['output'];
  /** Retrieve a list of "RecipeUrl" nodes. */
  recipeUrls: Array<RecipeUrl>;
  /** Get Tags suggestions for a recipe */
  suggestTags?: Maybe<TagSuggestionType>;
  /** Retrieve a single "Tag" node. */
  tag?: Maybe<Tag>;
  /** Retrieve the number of "Tag" nodes. */
  tagCount: Scalars['Int']['output'];
  /** Retrieve a list of "Tag" nodes. */
  tags: Array<Tag>;
  /** Retrieve a single "Url" node. */
  url?: Maybe<Url>;
  /** Retrieve the number of "Url" nodes. */
  urlCount: Scalars['Int']['output'];
  /** Retrieve a list of "Url" nodes. */
  urls: Array<Url>;
  /** Retrieve a single "VoiPublicId" node. */
  voiPublicId?: Maybe<VoiPublicId>;
  /** Retrieve the number of "VoiPublicId" nodes. */
  voiPublicIdCount: Scalars['Int']['output'];
  /** Retrieve a list of "VoiPublicId" nodes. */
  voiPublicIds: Array<VoiPublicId>;
};


export type QueryCacPublicIdArgs = {
  where: CacPublicIdWhereUniqueInput;
};


export type QueryCacPublicIdCountArgs = {
  where?: InputMaybe<CacPublicIdWhereInput>;
};


export type QueryCacPublicIdsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CacPublicIdOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CacPublicIdWhereInput>;
};


export type QueryCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type QueryCategoryCountArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


export type QueryCategoryUrlArgs = {
  where: CategoryUrlWhereUniqueInput;
};


export type QueryCategoryUrlCountArgs = {
  where?: InputMaybe<CategoryUrlWhereInput>;
};


export type QueryCategoryUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryUrlWhereInput>;
};


export type QueryFacPublicIdArgs = {
  where: FacPublicIdWhereUniqueInput;
};


export type QueryFacPublicIdCountArgs = {
  where?: InputMaybe<FacPublicIdWhereInput>;
};


export type QueryFacPublicIdsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<FacPublicIdOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FacPublicIdWhereInput>;
};


export type QueryGetAuthorRecipeCountArgs = {
  authorIds: Array<Scalars['String']['input']>;
  publishedFrom: Scalars['DateTime']['input'];
};


export type QueryGetMainCategoryAiArgs = {
  brandKey: BrandKey;
  recipe: Scalars['String']['input'];
};


export type QueryGetRecipeAdviceAiArgs = {
  advice?: InputMaybe<Scalars['String']['input']>;
  calorieLevel?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Int']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  estimatedCost?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Int']['input']>;
  rawIngredients?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  waitTime?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetRecipeCompleteAiArgs = {
  recipePrompt?: InputMaybe<Scalars['String']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRecipeLeadAiArgs = {
  advice?: InputMaybe<Scalars['String']['input']>;
  calorieLevel?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Int']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  estimatedCost?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Int']['input']>;
  rawIngredients?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  waitTime?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetVertexAiRecipesArgs = {
  brandKey: BrandKey;
  excludedIngredients?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
  recipeNumber: Scalars['Int']['input'];
};


export type QueryPromptArgs = {
  where: PromptWhereUniqueInput;
};


export type QueryPromptCountArgs = {
  where?: InputMaybe<PromptWhereInput>;
};


export type QueryPromptsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<PromptOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<PromptWhereInput>;
};


export type QueryRecipeArgs = {
  where: RecipeWhereUniqueInput;
};


export type QueryRecipeCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type QueryRecipeCategoryArgs = {
  where: RecipeCategoryWhereUniqueInput;
};


export type QueryRecipeCategoryCountArgs = {
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


export type QueryRecipeCountArgs = {
  where?: InputMaybe<RecipeWhereInput>;
};


export type QueryRecipeGuideArgs = {
  where: RecipeGuideWhereUniqueInput;
};


export type QueryRecipeGuideCountArgs = {
  where?: InputMaybe<RecipeGuideWhereInput>;
};


export type QueryRecipeGuidesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeGuideOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeGuideWhereInput>;
};


export type QueryRecipeHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeHistoryWhereInput>;
};


export type QueryRecipeHistoryArgs = {
  where: RecipeHistoryWhereUniqueInput;
};


export type QueryRecipeHistoryCountArgs = {
  where?: InputMaybe<RecipeHistoryWhereInput>;
};


export type QueryRecipesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeWhereInput>;
};


export type QueryRecipeTagArgs = {
  where: RecipeTagWhereUniqueInput;
};


export type QueryRecipeTagCountArgs = {
  where?: InputMaybe<RecipeTagWhereInput>;
};


export type QueryRecipeTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeTagWhereInput>;
};


export type QueryRecipeUrlArgs = {
  where: RecipeUrlWhereUniqueInput;
};


export type QueryRecipeUrlCountArgs = {
  where?: InputMaybe<RecipeUrlWhereInput>;
};


export type QueryRecipeUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeUrlWhereInput>;
};


export type QuerySuggestTagsArgs = {
  recipe: Scalars['String']['input'];
};


export type QueryTagArgs = {
  where: TagWhereUniqueInput;
};


export type QueryTagCountArgs = {
  where?: InputMaybe<TagWhereInput>;
};


export type QueryTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<TagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<TagWhereInput>;
};


export type QueryUrlArgs = {
  where: UrlWhereUniqueInput;
};


export type QueryUrlCountArgs = {
  where?: InputMaybe<UrlWhereInput>;
};


export type QueryUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<UrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UrlWhereInput>;
};


export type QueryVoiPublicIdArgs = {
  where: VoiPublicIdWhereUniqueInput;
};


export type QueryVoiPublicIdCountArgs = {
  where?: InputMaybe<VoiPublicIdWhereInput>;
};


export type QueryVoiPublicIdsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<VoiPublicIdOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VoiPublicIdWhereInput>;
};

/** Identifies exactly one "CacPublicId" node. */
export type CacPublicIdWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

/** "CacPublicId" resource's node */
export type CacPublicId = {
  __typename?: 'CacPublicId';
  /** The internal ID */
  id: Scalars['Int']['output'];
  urlId?: Maybe<Scalars['ID']['output']>;
};

/** Filters the "CacPublicId" nodes by specifying some conditions */
export type CacPublicIdWhereInput = {
  AND?: InputMaybe<Array<CacPublicIdWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  NOT?: InputMaybe<CacPublicIdWhereInput>;
  OR?: InputMaybe<Array<CacPublicIdWhereInput>>;
  urlId?: InputMaybe<Scalars['ID']['input']>;
  urlId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  urlId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  urlId_not?: InputMaybe<Scalars['ID']['input']>;
  urlId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum CacPublicIdOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  urlId_ASC = 'urlId_ASC',
  urlId_DESC = 'urlId_DESC'
}

export enum CategoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  left_ASC = 'left_ASC',
  left_DESC = 'left_DESC',
  level_ASC = 'level_ASC',
  level_DESC = 'level_DESC',
  medias_ASC = 'medias_ASC',
  medias_DESC = 'medias_DESC',
  right_ASC = 'right_ASC',
  right_DESC = 'right_DESC',
  rootId_ASC = 'rootId_ASC',
  rootId_DESC = 'rootId_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  subtitle_ASC = 'subtitle_ASC',
  subtitle_DESC = 'subtitle_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Filters the "Category" nodes by specifying some conditions */
export type CategoryWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<CategoryWhereInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_gt?: InputMaybe<Scalars['String']['input']>;
  body_gte?: InputMaybe<Scalars['String']['input']>;
  body_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  body_lt?: InputMaybe<Scalars['String']['input']>;
  body_lte?: InputMaybe<Scalars['String']['input']>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<Scalars['String']['input']>;
  brandKey_contains?: InputMaybe<Scalars['String']['input']>;
  brandKey_ends_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_gt?: InputMaybe<Scalars['String']['input']>;
  brandKey_gte?: InputMaybe<Scalars['String']['input']>;
  brandKey_in?: InputMaybe<Array<Scalars['String']['input']>>;
  brandKey_lt?: InputMaybe<Scalars['String']['input']>;
  brandKey_lte?: InputMaybe<Scalars['String']['input']>;
  brandKey_not?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  brandKey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_starts_with?: InputMaybe<Scalars['String']['input']>;
  categoryUrls_some?: InputMaybe<CategoryUrlWhereInput>;
  children_some?: InputMaybe<CategoryWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  left?: InputMaybe<Scalars['Int']['input']>;
  left_gt?: InputMaybe<Scalars['Int']['input']>;
  left_gte?: InputMaybe<Scalars['Int']['input']>;
  left_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  left_lt?: InputMaybe<Scalars['Int']['input']>;
  left_lte?: InputMaybe<Scalars['Int']['input']>;
  left_not?: InputMaybe<Scalars['Int']['input']>;
  left_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  level?: InputMaybe<Scalars['Int']['input']>;
  level_gt?: InputMaybe<Scalars['Int']['input']>;
  level_gte?: InputMaybe<Scalars['Int']['input']>;
  level_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  level_lt?: InputMaybe<Scalars['Int']['input']>;
  level_lte?: InputMaybe<Scalars['Int']['input']>;
  level_not?: InputMaybe<Scalars['Int']['input']>;
  level_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  medias?: InputMaybe<Scalars['String']['input']>;
  medias_contains?: InputMaybe<Scalars['String']['input']>;
  medias_ends_with?: InputMaybe<Scalars['String']['input']>;
  medias_gt?: InputMaybe<Scalars['String']['input']>;
  medias_gte?: InputMaybe<Scalars['String']['input']>;
  medias_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  medias_lt?: InputMaybe<Scalars['String']['input']>;
  medias_lte?: InputMaybe<Scalars['String']['input']>;
  medias_not?: InputMaybe<Scalars['String']['input']>;
  medias_not_contains?: InputMaybe<Scalars['String']['input']>;
  medias_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  medias_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medias_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  medias_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<CategoryWhereInput>;
  OR?: InputMaybe<Array<CategoryWhereInput>>;
  parent?: InputMaybe<CategoryWhereInput>;
  parent_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  right?: InputMaybe<Scalars['Int']['input']>;
  right_gt?: InputMaybe<Scalars['Int']['input']>;
  right_gte?: InputMaybe<Scalars['Int']['input']>;
  right_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  right_lt?: InputMaybe<Scalars['Int']['input']>;
  right_lte?: InputMaybe<Scalars['Int']['input']>;
  right_not?: InputMaybe<Scalars['Int']['input']>;
  right_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  rootId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  rootId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  rootId_not?: InputMaybe<Scalars['ID']['input']>;
  rootId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  status_contains?: InputMaybe<Scalars['String']['input']>;
  status_ends_with?: InputMaybe<Scalars['String']['input']>;
  status_gt?: InputMaybe<Scalars['String']['input']>;
  status_gte?: InputMaybe<Scalars['String']['input']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status_lt?: InputMaybe<Scalars['String']['input']>;
  status_lte?: InputMaybe<Scalars['String']['input']>;
  status_not?: InputMaybe<Scalars['String']['input']>;
  status_not_contains?: InputMaybe<Scalars['String']['input']>;
  status_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  status_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  status_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  subtitle_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_ends_with?: InputMaybe<Scalars['String']['input']>;
  subtitle_gt?: InputMaybe<Scalars['String']['input']>;
  subtitle_gte?: InputMaybe<Scalars['String']['input']>;
  subtitle_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  subtitle_lt?: InputMaybe<Scalars['String']['input']>;
  subtitle_lte?: InputMaybe<Scalars['String']['input']>;
  subtitle_not?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_contains?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  subtitle_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subtitle_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  subtitle_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Filters the "CategoryUrl" nodes by specifying some conditions */
export type CategoryUrlWhereInput = {
  AND?: InputMaybe<Array<CategoryUrlWhereInput>>;
  category?: InputMaybe<CategoryWhereInput>;
  category_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<CategoryUrlWhereInput>;
  OR?: InputMaybe<Array<CategoryUrlWhereInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_gt?: InputMaybe<Scalars['Int']['input']>;
  position_gte?: InputMaybe<Scalars['Int']['input']>;
  position_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_lt?: InputMaybe<Scalars['Int']['input']>;
  position_lte?: InputMaybe<Scalars['Int']['input']>;
  position_not?: InputMaybe<Scalars['Int']['input']>;
  position_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  url?: InputMaybe<UrlWhereInput>;
  url_is_null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters the "Url" nodes by specifying some conditions */
export type UrlWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<UrlWhereInput>>;
  brandKey?: InputMaybe<Scalars['String']['input']>;
  brandKey_contains?: InputMaybe<Scalars['String']['input']>;
  brandKey_ends_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_gt?: InputMaybe<Scalars['String']['input']>;
  brandKey_gte?: InputMaybe<Scalars['String']['input']>;
  brandKey_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandKey_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  brandKey_lt?: InputMaybe<Scalars['String']['input']>;
  brandKey_lte?: InputMaybe<Scalars['String']['input']>;
  brandKey_not?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  brandKey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_starts_with?: InputMaybe<Scalars['String']['input']>;
  categoryUrls_some?: InputMaybe<CategoryUrlWhereInput>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<UrlWhereInput>;
  OR?: InputMaybe<Array<UrlWhereInput>>;
  path?: InputMaybe<Scalars['String']['input']>;
  path_contains?: InputMaybe<Scalars['String']['input']>;
  path_ends_with?: InputMaybe<Scalars['String']['input']>;
  path_gt?: InputMaybe<Scalars['String']['input']>;
  path_gte?: InputMaybe<Scalars['String']['input']>;
  path_in?: InputMaybe<Array<Scalars['String']['input']>>;
  path_lt?: InputMaybe<Scalars['String']['input']>;
  path_lte?: InputMaybe<Scalars['String']['input']>;
  path_not?: InputMaybe<Scalars['String']['input']>;
  path_not_contains?: InputMaybe<Scalars['String']['input']>;
  path_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  path_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  path_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  path_starts_with?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  publicId_contains?: InputMaybe<Scalars['String']['input']>;
  publicId_ends_with?: InputMaybe<Scalars['String']['input']>;
  publicId_gt?: InputMaybe<Scalars['String']['input']>;
  publicId_gte?: InputMaybe<Scalars['String']['input']>;
  publicId_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publicId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publicId_lt?: InputMaybe<Scalars['String']['input']>;
  publicId_lte?: InputMaybe<Scalars['String']['input']>;
  publicId_not?: InputMaybe<Scalars['String']['input']>;
  publicId_not_contains?: InputMaybe<Scalars['String']['input']>;
  publicId_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  publicId_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publicId_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  publicId_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipeUrls_some?: InputMaybe<RecipeUrlWhereInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** Filters the "RecipeUrl" nodes by specifying some conditions */
export type RecipeUrlWhereInput = {
  AND?: InputMaybe<Array<RecipeUrlWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<RecipeUrlWhereInput>;
  OR?: InputMaybe<Array<RecipeUrlWhereInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_gt?: InputMaybe<Scalars['Int']['input']>;
  position_gte?: InputMaybe<Scalars['Int']['input']>;
  position_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_lt?: InputMaybe<Scalars['Int']['input']>;
  position_lte?: InputMaybe<Scalars['Int']['input']>;
  position_not?: InputMaybe<Scalars['Int']['input']>;
  position_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  recipe?: InputMaybe<RecipeWhereInput>;
  recipe_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<UrlWhereInput>;
  url_is_null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters the "Recipe" nodes by specifying some conditions */
export type RecipeWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  advice?: InputMaybe<Scalars['String']['input']>;
  advice_contains?: InputMaybe<Scalars['String']['input']>;
  advice_ends_with?: InputMaybe<Scalars['String']['input']>;
  advice_gt?: InputMaybe<Scalars['String']['input']>;
  advice_gte?: InputMaybe<Scalars['String']['input']>;
  advice_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  advice_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  advice_lt?: InputMaybe<Scalars['String']['input']>;
  advice_lte?: InputMaybe<Scalars['String']['input']>;
  advice_not?: InputMaybe<Scalars['String']['input']>;
  advice_not_contains?: InputMaybe<Scalars['String']['input']>;
  advice_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  advice_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  advice_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  advice_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiGenerated?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_contains?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_gt?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_gte?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiGenerated_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  aiGenerated_lt?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_lte?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_not?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_not_contains?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aiGenerated_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  aiGenerated_starts_with?: InputMaybe<Scalars['String']['input']>;
  AND?: InputMaybe<Array<RecipeWhereInput>>;
  author?: InputMaybe<Scalars['ID']['input']>;
  author_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  author_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  author_not?: InputMaybe<Scalars['ID']['input']>;
  author_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  brandKey?: InputMaybe<Scalars['String']['input']>;
  brandKey_contains?: InputMaybe<Scalars['String']['input']>;
  brandKey_ends_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_gt?: InputMaybe<Scalars['String']['input']>;
  brandKey_gte?: InputMaybe<Scalars['String']['input']>;
  brandKey_in?: InputMaybe<Array<Scalars['String']['input']>>;
  brandKey_lt?: InputMaybe<Scalars['String']['input']>;
  brandKey_lte?: InputMaybe<Scalars['String']['input']>;
  brandKey_not?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_contains?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  brandKey_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  brandKey_starts_with?: InputMaybe<Scalars['String']['input']>;
  calorieLevel?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_contains?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_ends_with?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_gt?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_gte?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  calorieLevel_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  calorieLevel_lt?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_lte?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_not?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_not_contains?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  calorieLevel_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  calorieLevel_starts_with?: InputMaybe<Scalars['String']['input']>;
  cookingMethod?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_contains?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_ends_with?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_gt?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_gte?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cookingMethod_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  cookingMethod_lt?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_lte?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_not?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_not_contains?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cookingMethod_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  cookingMethod_starts_with?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Int']['input']>;
  cookTime_gt?: InputMaybe<Scalars['Int']['input']>;
  cookTime_gte?: InputMaybe<Scalars['Int']['input']>;
  cookTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cookTime_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  cookTime_lt?: InputMaybe<Scalars['Int']['input']>;
  cookTime_lte?: InputMaybe<Scalars['Int']['input']>;
  cookTime_not?: InputMaybe<Scalars['Int']['input']>;
  cookTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  creatorId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  creatorId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  creatorId_not?: InputMaybe<Scalars['ID']['input']>;
  creatorId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  difficulty_contains?: InputMaybe<Scalars['String']['input']>;
  difficulty_ends_with?: InputMaybe<Scalars['String']['input']>;
  difficulty_gt?: InputMaybe<Scalars['String']['input']>;
  difficulty_gte?: InputMaybe<Scalars['String']['input']>;
  difficulty_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  difficulty_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  difficulty_lt?: InputMaybe<Scalars['String']['input']>;
  difficulty_lte?: InputMaybe<Scalars['String']['input']>;
  difficulty_not?: InputMaybe<Scalars['String']['input']>;
  difficulty_not_contains?: InputMaybe<Scalars['String']['input']>;
  difficulty_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  difficulty_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  difficulty_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  difficulty_starts_with?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  editedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  editedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  editedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  estimatedCost?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_contains?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_ends_with?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_gt?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_gte?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  estimatedCost_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedCost_lt?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_lte?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_not?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_not_contains?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  estimatedCost_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  estimatedCost_starts_with?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  instructions_contains?: InputMaybe<Scalars['String']['input']>;
  instructions_ends_with?: InputMaybe<Scalars['String']['input']>;
  instructions_gt?: InputMaybe<Scalars['String']['input']>;
  instructions_gte?: InputMaybe<Scalars['String']['input']>;
  instructions_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instructions_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  instructions_lt?: InputMaybe<Scalars['String']['input']>;
  instructions_lte?: InputMaybe<Scalars['String']['input']>;
  instructions_not?: InputMaybe<Scalars['String']['input']>;
  instructions_not_contains?: InputMaybe<Scalars['String']['input']>;
  instructions_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  instructions_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instructions_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  instructions_starts_with?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  lead_contains?: InputMaybe<Scalars['String']['input']>;
  lead_ends_with?: InputMaybe<Scalars['String']['input']>;
  lead_gt?: InputMaybe<Scalars['String']['input']>;
  lead_gte?: InputMaybe<Scalars['String']['input']>;
  lead_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lead_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lead_lt?: InputMaybe<Scalars['String']['input']>;
  lead_lte?: InputMaybe<Scalars['String']['input']>;
  lead_not?: InputMaybe<Scalars['String']['input']>;
  lead_not_contains?: InputMaybe<Scalars['String']['input']>;
  lead_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  lead_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lead_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  lead_starts_with?: InputMaybe<Scalars['String']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  legacyId_gt?: InputMaybe<Scalars['Int']['input']>;
  legacyId_gte?: InputMaybe<Scalars['Int']['input']>;
  legacyId_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  legacyId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId_lt?: InputMaybe<Scalars['Int']['input']>;
  legacyId_lte?: InputMaybe<Scalars['Int']['input']>;
  legacyId_not?: InputMaybe<Scalars['Int']['input']>;
  legacyId_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lockedAt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  lockedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  lockerId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lockerId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  lockerId_not?: InputMaybe<Scalars['ID']['input']>;
  lockerId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  medias?: InputMaybe<Scalars['String']['input']>;
  medias_contains?: InputMaybe<Scalars['String']['input']>;
  medias_ends_with?: InputMaybe<Scalars['String']['input']>;
  medias_gt?: InputMaybe<Scalars['String']['input']>;
  medias_gte?: InputMaybe<Scalars['String']['input']>;
  medias_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medias_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  medias_lt?: InputMaybe<Scalars['String']['input']>;
  medias_lte?: InputMaybe<Scalars['String']['input']>;
  medias_not?: InputMaybe<Scalars['String']['input']>;
  medias_not_contains?: InputMaybe<Scalars['String']['input']>;
  medias_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  medias_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medias_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  medias_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<RecipeWhereInput>;
  OR?: InputMaybe<Array<RecipeWhereInput>>;
  parsedIngredients?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_contains?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_ends_with?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_gt?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_gte?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_in?: InputMaybe<Array<Scalars['String']['input']>>;
  parsedIngredients_lt?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_lte?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_not?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_not_contains?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  parsedIngredients_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients_starts_with?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Int']['input']>;
  prepTime_gt?: InputMaybe<Scalars['Int']['input']>;
  prepTime_gte?: InputMaybe<Scalars['Int']['input']>;
  prepTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  prepTime_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  prepTime_lt?: InputMaybe<Scalars['Int']['input']>;
  prepTime_lte?: InputMaybe<Scalars['Int']['input']>;
  prepTime_not?: InputMaybe<Scalars['Int']['input']>;
  prepTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  rawIngredients?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_contains?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_ends_with?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_gt?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_gte?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rawIngredients_lt?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_lte?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_not?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_not_contains?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  rawIngredients_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  rawIngredients_starts_with?: InputMaybe<Scalars['String']['input']>;
  recipeCategories_some?: InputMaybe<RecipeCategoryWhereInput>;
  recipeGuides_some?: InputMaybe<RecipeGuideWhereInput>;
  recipeHistories_some?: InputMaybe<RecipeHistoryWhereInput>;
  recipeTags_some?: InputMaybe<RecipeTagWhereInput>;
  recipeUrls_some?: InputMaybe<RecipeUrlWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  source_contains?: InputMaybe<Scalars['String']['input']>;
  source_ends_with?: InputMaybe<Scalars['String']['input']>;
  source_gt?: InputMaybe<Scalars['String']['input']>;
  source_gte?: InputMaybe<Scalars['String']['input']>;
  source_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  source_lt?: InputMaybe<Scalars['String']['input']>;
  source_lte?: InputMaybe<Scalars['String']['input']>;
  source_not?: InputMaybe<Scalars['String']['input']>;
  source_not_contains?: InputMaybe<Scalars['String']['input']>;
  source_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  source_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  source_starts_with?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RecipeStatus>;
  status_in?: InputMaybe<Array<InputMaybe<RecipeStatus>>>;
  status_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status_not?: InputMaybe<RecipeStatus>;
  status_not_in?: InputMaybe<Array<InputMaybe<RecipeStatus>>>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  totalTime?: InputMaybe<Scalars['Int']['input']>;
  totalTime_gt?: InputMaybe<Scalars['Int']['input']>;
  totalTime_gte?: InputMaybe<Scalars['Int']['input']>;
  totalTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalTime_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  totalTime_lt?: InputMaybe<Scalars['Int']['input']>;
  totalTime_lte?: InputMaybe<Scalars['Int']['input']>;
  totalTime_not?: InputMaybe<Scalars['Int']['input']>;
  totalTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  unparsedIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  unparsedIngredients_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  unparsedIngredients_not?: InputMaybe<Scalars['Boolean']['input']>;
  unparsedIngredients_not_in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  waitTime?: InputMaybe<Scalars['Int']['input']>;
  waitTime_gt?: InputMaybe<Scalars['Int']['input']>;
  waitTime_gte?: InputMaybe<Scalars['Int']['input']>;
  waitTime_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  waitTime_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  waitTime_lt?: InputMaybe<Scalars['Int']['input']>;
  waitTime_lte?: InputMaybe<Scalars['Int']['input']>;
  waitTime_not?: InputMaybe<Scalars['Int']['input']>;
  waitTime_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  yield?: InputMaybe<Scalars['Int']['input']>;
  yield_gt?: InputMaybe<Scalars['Int']['input']>;
  yield_gte?: InputMaybe<Scalars['Int']['input']>;
  yield_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  yield_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  yield_lt?: InputMaybe<Scalars['Int']['input']>;
  yield_lte?: InputMaybe<Scalars['Int']['input']>;
  yield_not?: InputMaybe<Scalars['Int']['input']>;
  yield_not_in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

/** Filters the "RecipeCategory" nodes by specifying some conditions */
export type RecipeCategoryWhereInput = {
  AND?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  category?: InputMaybe<CategoryWhereInput>;
  category_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<RecipeCategoryWhereInput>;
  OR?: InputMaybe<Array<RecipeCategoryWhereInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_gt?: InputMaybe<Scalars['Int']['input']>;
  position_gte?: InputMaybe<Scalars['Int']['input']>;
  position_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_lt?: InputMaybe<Scalars['Int']['input']>;
  position_lte?: InputMaybe<Scalars['Int']['input']>;
  position_not?: InputMaybe<Scalars['Int']['input']>;
  position_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  recipe?: InputMaybe<RecipeWhereInput>;
  recipe_is_null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters the "RecipeGuide" nodes by specifying some conditions */
export type RecipeGuideWhereInput = {
  AND?: InputMaybe<Array<RecipeGuideWhereInput>>;
  guideId?: InputMaybe<Scalars['ID']['input']>;
  guideId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  guideId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  guideId_not?: InputMaybe<Scalars['ID']['input']>;
  guideId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<RecipeGuideWhereInput>;
  OR?: InputMaybe<Array<RecipeGuideWhereInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  position_gt?: InputMaybe<Scalars['Int']['input']>;
  position_gte?: InputMaybe<Scalars['Int']['input']>;
  position_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  position_lt?: InputMaybe<Scalars['Int']['input']>;
  position_lte?: InputMaybe<Scalars['Int']['input']>;
  position_not?: InputMaybe<Scalars['Int']['input']>;
  position_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  recipe?: InputMaybe<RecipeWhereInput>;
  recipe_is_null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters the "RecipeHistory" nodes by specifying some conditions */
export type RecipeHistoryWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<RecipeHistoryWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<RecipeHistoryWhereInput>;
  OR?: InputMaybe<Array<RecipeHistoryWhereInput>>;
  recipe?: InputMaybe<RecipeWhereInput>;
  status?: InputMaybe<RecipeStatus>;
  status_in?: InputMaybe<Array<InputMaybe<RecipeStatus>>>;
  status_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  status_not?: InputMaybe<RecipeStatus>;
  status_not_in?: InputMaybe<Array<InputMaybe<RecipeStatus>>>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  userId_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId_not?: InputMaybe<Scalars['ID']['input']>;
  userId_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum RecipeStatus {
  Deleted = 'Deleted',
  Draft = 'Draft',
  Frozen = 'Frozen',
  Published = 'Published',
  Ready = 'Ready',
  Scheduled = 'Scheduled'
}

/** Filters the "RecipeTag" nodes by specifying some conditions */
export type RecipeTagWhereInput = {
  AND?: InputMaybe<Array<RecipeTagWhereInput>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<RecipeTagWhereInput>;
  OR?: InputMaybe<Array<RecipeTagWhereInput>>;
  recipe?: InputMaybe<RecipeWhereInput>;
  recipe_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<TagWhereInput>;
  tag_is_null?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Filters the "Tag" nodes by specifying some conditions */
export type TagWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<TagWhereInput>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  NOT?: InputMaybe<TagWhereInput>;
  OR?: InputMaybe<Array<TagWhereInput>>;
  recipeTags_some?: InputMaybe<RecipeTagWhereInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  slug_contains?: InputMaybe<Scalars['String']['input']>;
  slug_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_gt?: InputMaybe<Scalars['String']['input']>;
  slug_gte?: InputMaybe<Scalars['String']['input']>;
  slug_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  slug_lt?: InputMaybe<Scalars['String']['input']>;
  slug_lte?: InputMaybe<Scalars['String']['input']>;
  slug_not?: InputMaybe<Scalars['String']['input']>;
  slug_not_contains?: InputMaybe<Scalars['String']['input']>;
  slug_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  slug_not_in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  slug_starts_with?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  title_contains?: InputMaybe<Scalars['String']['input']>;
  title_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_gt?: InputMaybe<Scalars['String']['input']>;
  title_gte?: InputMaybe<Scalars['String']['input']>;
  title_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_lt?: InputMaybe<Scalars['String']['input']>;
  title_lte?: InputMaybe<Scalars['String']['input']>;
  title_not?: InputMaybe<Scalars['String']['input']>;
  title_not_contains?: InputMaybe<Scalars['String']['input']>;
  title_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  title_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  title_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  title_starts_with?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

/** "Category" resource's node */
export type Category = {
  __typename?: 'Category';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  body?: Maybe<Scalars['String']['output']>;
  brandKey: Scalars['String']['output'];
  /** "CategoryUrl.category"'s inverse relation count */
  categoryUrlCount: Scalars['Int']['output'];
  /** "CategoryUrl.category"'s inverse relation */
  categoryUrls: Array<CategoryUrl>;
  /** "Category.parent"'s inverse relation count */
  childCount: Scalars['Int']['output'];
  /** "Category.parent"'s inverse relation */
  children: Array<Category>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  left: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  medias?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Category>;
  /** "RecipeCategory.category"'s inverse relation */
  recipeCategories: Array<RecipeCategory>;
  /** "RecipeCategory.category"'s inverse relation count */
  recipeCategoryCount: Scalars['Int']['output'];
  right: Scalars['Int']['output'];
  rootId?: Maybe<Scalars['ID']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** "Category" resource's node */
export type CategoryCategoryUrlCountArgs = {
  where?: InputMaybe<CategoryUrlWhereInput>;
};


/** "Category" resource's node */
export type CategoryCategoryUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryUrlWhereInput>;
};


/** "Category" resource's node */
export type CategoryChildCountArgs = {
  where?: InputMaybe<CategoryWhereInput>;
};


/** "Category" resource's node */
export type CategoryChildrenArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryWhereInput>;
};


/** "Category" resource's node */
export type CategoryRecipeCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** "Category" resource's node */
export type CategoryRecipeCategoryCountArgs = {
  where?: InputMaybe<RecipeCategoryWhereInput>;
};

export enum CategoryUrlOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC'
}

/** "CategoryUrl" resource's node */
export type CategoryUrl = {
  __typename?: 'CategoryUrl';
  category?: Maybe<Category>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  url?: Maybe<Url>;
};

/** "Url" resource's node */
export type Url = {
  __typename?: 'Url';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  brandKey?: Maybe<Scalars['String']['output']>;
  /** "CategoryUrl.url"'s inverse relation count */
  categoryUrlCount: Scalars['Int']['output'];
  /** "CategoryUrl.url"'s inverse relation */
  categoryUrls: Array<CategoryUrl>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
  publicId?: Maybe<Scalars['String']['output']>;
  /** "RecipeUrl.url"'s inverse relation count */
  recipeUrlCount: Scalars['Int']['output'];
  /** "RecipeUrl.url"'s inverse relation */
  recipeUrls: Array<RecipeUrl>;
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** "Url" resource's node */
export type UrlCategoryUrlCountArgs = {
  where?: InputMaybe<CategoryUrlWhereInput>;
};


/** "Url" resource's node */
export type UrlCategoryUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<CategoryUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CategoryUrlWhereInput>;
};


/** "Url" resource's node */
export type UrlRecipeUrlCountArgs = {
  where?: InputMaybe<RecipeUrlWhereInput>;
};


/** "Url" resource's node */
export type UrlRecipeUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeUrlWhereInput>;
};

export enum RecipeUrlOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC'
}

/** "RecipeUrl" resource's node */
export type RecipeUrl = {
  __typename?: 'RecipeUrl';
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  recipe?: Maybe<Recipe>;
  url?: Maybe<Url>;
};

/** "Recipe" resource's node */
export type Recipe = {
  __typename?: 'Recipe';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  advice?: Maybe<Scalars['String']['output']>;
  /** Represents the list of fields generated by AI in the front application before saving the recipe */
  aiGenerated?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['ID']['output']>;
  authorName?: Maybe<Scalars['String']['output']>;
  brandKey: Scalars['String']['output'];
  calorieLevel?: Maybe<Scalars['String']['output']>;
  cookingMethod?: Maybe<Scalars['String']['output']>;
  cookTime?: Maybe<Scalars['Int']['output']>;
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  difficulty?: Maybe<Scalars['String']['output']>;
  editedAt?: Maybe<Scalars['DateTime']['output']>;
  estimatedCost?: Maybe<Scalars['String']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  /** State of current recipe (locked or not) */
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  lead?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  /** The date of the recipe's last lock */
  lockedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user currently locking the recipe */
  lockedBy?: Maybe<User>;
  lockerId?: Maybe<Scalars['ID']['output']>;
  medias?: Maybe<Scalars['String']['output']>;
  parsedIngredients: Scalars['String']['output'];
  prepTime?: Maybe<Scalars['Int']['output']>;
  /** The date of the document's publication */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  rawIngredients: Scalars['String']['output'];
  /** "RecipeCategory.recipe"'s inverse relation */
  recipeCategories: Array<RecipeCategory>;
  /** "RecipeCategory.recipe"'s inverse relation count */
  recipeCategoryCount: Scalars['Int']['output'];
  /** "RecipeGuide.recipe"'s inverse relation count */
  recipeGuideCount: Scalars['Int']['output'];
  /** "RecipeGuide.recipe"'s inverse relation */
  recipeGuides: Array<RecipeGuide>;
  /** "RecipeHistory.recipe"'s inverse relation */
  recipeHistories: Array<RecipeHistory>;
  /** "RecipeHistory.recipe"'s inverse relation count */
  recipeHistoryCount: Scalars['Int']['output'];
  /** "RecipeTag.recipe"'s inverse relation count */
  recipeTagCount: Scalars['Int']['output'];
  /** "RecipeTag.recipe"'s inverse relation */
  recipeTags: Array<RecipeTag>;
  /** "RecipeUrl.recipe"'s inverse relation count */
  recipeUrlCount: Scalars['Int']['output'];
  /** "RecipeUrl.recipe"'s inverse relation */
  recipeUrls: Array<RecipeUrl>;
  slug?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<RecipeStatus>;
  title: Scalars['String']['output'];
  totalTime?: Maybe<Scalars['Int']['output']>;
  unparsedIngredients: Scalars['Boolean']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
  waitTime?: Maybe<Scalars['Int']['output']>;
  yield?: Maybe<Scalars['Int']['output']>;
};


/** "Recipe" resource's node */
export type RecipeRecipeCategoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeCategoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeCategoryCountArgs = {
  where?: InputMaybe<RecipeCategoryWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeGuideCountArgs = {
  where?: InputMaybe<RecipeGuideWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeGuidesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeGuideOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeGuideWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeHistoriesArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeHistoryOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeHistoryWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeHistoryCountArgs = {
  where?: InputMaybe<RecipeHistoryWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeTagCountArgs = {
  where?: InputMaybe<RecipeTagWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeTagWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeUrlCountArgs = {
  where?: InputMaybe<RecipeUrlWhereInput>;
};


/** "Recipe" resource's node */
export type RecipeRecipeUrlsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeUrlOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeUrlWhereInput>;
};

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum RecipeCategoryOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC'
}

/** "RecipeCategory" resource's node */
export type RecipeCategory = {
  __typename?: 'RecipeCategory';
  category?: Maybe<Category>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  recipe?: Maybe<Recipe>;
};

export enum RecipeGuideOrderByInput {
  guideId_ASC = 'guideId_ASC',
  guideId_DESC = 'guideId_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  position_ASC = 'position_ASC',
  position_DESC = 'position_DESC'
}

/** "RecipeGuide" resource's node */
export type RecipeGuide = {
  __typename?: 'RecipeGuide';
  guideId?: Maybe<Scalars['ID']['output']>;
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  recipe?: Maybe<Recipe>;
};

export enum RecipeHistoryOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  userId_ASC = 'userId_ASC',
  userId_DESC = 'userId_DESC'
}

/** "RecipeHistory" resource's node */
export type RecipeHistory = {
  __typename?: 'RecipeHistory';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  recipe: Recipe;
  status?: Maybe<RecipeStatus>;
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export enum RecipeTagOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC'
}

/** "RecipeTag" resource's node */
export type RecipeTag = {
  __typename?: 'RecipeTag';
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  recipe?: Maybe<Recipe>;
  tag?: Maybe<Tag>;
};

/** "Tag" resource's node */
export type Tag = {
  __typename?: 'Tag';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  /** "RecipeTag.tag"'s inverse relation count */
  recipeTagCount: Scalars['Int']['output'];
  /** "RecipeTag.tag"'s inverse relation */
  recipeTags: Array<RecipeTag>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};


/** "Tag" resource's node */
export type TagRecipeTagCountArgs = {
  where?: InputMaybe<RecipeTagWhereInput>;
};


/** "Tag" resource's node */
export type TagRecipeTagsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<RecipeTagOrderByInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RecipeTagWhereInput>;
};

/**
 * Identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - parent, slug
 */
export type CategoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parent?: InputMaybe<CategoryWhereUniqueInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "CategoryUrl" node. */
export type CategoryUrlWhereUniqueInput = {
  id: Scalars['ID']['input'];
};

/** Identifies exactly one "FacPublicId" node. */
export type FacPublicIdWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

/** "FacPublicId" resource's node */
export type FacPublicId = {
  __typename?: 'FacPublicId';
  /** The internal ID */
  id: Scalars['Int']['output'];
  urlId?: Maybe<Scalars['ID']['output']>;
};

/** Filters the "FacPublicId" nodes by specifying some conditions */
export type FacPublicIdWhereInput = {
  AND?: InputMaybe<Array<FacPublicIdWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  NOT?: InputMaybe<FacPublicIdWhereInput>;
  OR?: InputMaybe<Array<FacPublicIdWhereInput>>;
  urlId?: InputMaybe<Scalars['ID']['input']>;
  urlId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  urlId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  urlId_not?: InputMaybe<Scalars['ID']['input']>;
  urlId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum FacPublicIdOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  urlId_ASC = 'urlId_ASC',
  urlId_DESC = 'urlId_DESC'
}

export type AuthorRecipeCount = {
  __typename?: 'AuthorRecipeCount';
  authorId: Scalars['String']['output'];
  CAC: CacAuthorRecipeCount;
  FAC: FacAuthorRecipeCount;
};

export type CacAuthorRecipeCount = {
  __typename?: 'CACAuthorRecipeCount';
  active: Scalars['Int']['output'];
  existing: Scalars['Int']['output'];
};

export type FacAuthorRecipeCount = {
  __typename?: 'FACAuthorRecipeCount';
  active: Scalars['Int']['output'];
  existing: Scalars['Int']['output'];
};

export enum BrandKey {
  CAC = 'CAC',
  FAC = 'FAC',
  VOI = 'VOI'
}

export type MainCategoryAiType = {
  __typename?: 'MainCategoryAIType';
  category?: Maybe<MainCategoryAiResultType>;
};

export type MainCategoryAiResultType = {
  __typename?: 'MainCategoryAIResultType';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type RecipeAdviceAiType = {
  __typename?: 'RecipeAdviceAIType';
  advice: Scalars['String']['output'];
};

export type RecipeCompleteAiType = {
  __typename?: 'RecipeCompleteAIType';
  recipe: Scalars['String']['output'];
};

export type RecipeLeadAiType = {
  __typename?: 'RecipeLeadAIType';
  lead: Scalars['String']['output'];
};

export type VertexAiRecipesResultType = {
  __typename?: 'vertexAIRecipesResultType';
  ingredients: Array<VertexAiRecipesIngredientsType>;
  recipesIds: Array<Scalars['String']['output']>;
};

export type VertexAiRecipesIngredientsType = {
  __typename?: 'vertexAIRecipesIngredientsType';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/**
 * Identifies exactly one "Prompt" node with one of these unique values:
 * - _id
 * - id
 * - label
 */
export type PromptWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

/** "Prompt" resource's node */
export type Prompt = {
  __typename?: 'Prompt';
  /** The internal ID */
  _id: Scalars['Int']['output'];
  body: Scalars['String']['output'];
  /** The date, fixed, of the document's creation */
  createdAt: Scalars['DateTime']['output'];
  /** The public ID, an UUID v4 */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  /** The date of the document's last update */
  updatedAt: Scalars['DateTime']['output'];
};

/** Filters the "Prompt" nodes by specifying some conditions */
export type PromptWhereInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  _id_gt?: InputMaybe<Scalars['Int']['input']>;
  _id_gte?: InputMaybe<Scalars['Int']['input']>;
  _id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _id_lt?: InputMaybe<Scalars['Int']['input']>;
  _id_lte?: InputMaybe<Scalars['Int']['input']>;
  _id_not?: InputMaybe<Scalars['Int']['input']>;
  _id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  AND?: InputMaybe<Array<PromptWhereInput>>;
  body?: InputMaybe<Scalars['String']['input']>;
  body_contains?: InputMaybe<Scalars['String']['input']>;
  body_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_gt?: InputMaybe<Scalars['String']['input']>;
  body_gte?: InputMaybe<Scalars['String']['input']>;
  body_in?: InputMaybe<Array<Scalars['String']['input']>>;
  body_lt?: InputMaybe<Scalars['String']['input']>;
  body_lte?: InputMaybe<Scalars['String']['input']>;
  body_not?: InputMaybe<Scalars['String']['input']>;
  body_not_contains?: InputMaybe<Scalars['String']['input']>;
  body_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  body_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  body_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  body_starts_with?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  createdAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  createdAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  id_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  id_not?: InputMaybe<Scalars['ID']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['ID']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  label_contains?: InputMaybe<Scalars['String']['input']>;
  label_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_gt?: InputMaybe<Scalars['String']['input']>;
  label_gte?: InputMaybe<Scalars['String']['input']>;
  label_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_lt?: InputMaybe<Scalars['String']['input']>;
  label_lte?: InputMaybe<Scalars['String']['input']>;
  label_not?: InputMaybe<Scalars['String']['input']>;
  label_not_contains?: InputMaybe<Scalars['String']['input']>;
  label_not_ends_with?: InputMaybe<Scalars['String']['input']>;
  label_not_in?: InputMaybe<Array<Scalars['String']['input']>>;
  label_not_starts_with?: InputMaybe<Scalars['String']['input']>;
  label_starts_with?: InputMaybe<Scalars['String']['input']>;
  NOT?: InputMaybe<PromptWhereInput>;
  OR?: InputMaybe<Array<PromptWhereInput>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_gte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  updatedAt_lt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_lte?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not?: InputMaybe<Scalars['DateTime']['input']>;
  updatedAt_not_in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export enum PromptOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  body_ASC = 'body_ASC',
  body_DESC = 'body_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  label_ASC = 'label_ASC',
  label_DESC = 'label_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * Identifies exactly one "Recipe" node with one of these unique combinations of values:
 * - _id
 * - id
 * - slug
 * - brandKey, legacyId
 */
export type RecipeWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies exactly one "RecipeCategory" node. */
export type RecipeCategoryWhereUniqueInput = {
  id: Scalars['ID']['input'];
};

/** Identifies exactly one "RecipeGuide" node. */
export type RecipeGuideWhereUniqueInput = {
  id: Scalars['ID']['input'];
};

/**
 * Identifies exactly one "RecipeHistory" node with one of these unique values:
 * - _id
 * - id
 */
export type RecipeHistoryWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export enum RecipeOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  advice_ASC = 'advice_ASC',
  advice_DESC = 'advice_DESC',
  aiGenerated_ASC = 'aiGenerated_ASC',
  aiGenerated_DESC = 'aiGenerated_DESC',
  author_ASC = 'author_ASC',
  author_DESC = 'author_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  calorieLevel_ASC = 'calorieLevel_ASC',
  calorieLevel_DESC = 'calorieLevel_DESC',
  cookingMethod_ASC = 'cookingMethod_ASC',
  cookingMethod_DESC = 'cookingMethod_DESC',
  cookTime_ASC = 'cookTime_ASC',
  cookTime_DESC = 'cookTime_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  creatorId_ASC = 'creatorId_ASC',
  creatorId_DESC = 'creatorId_DESC',
  difficulty_ASC = 'difficulty_ASC',
  difficulty_DESC = 'difficulty_DESC',
  editedAt_ASC = 'editedAt_ASC',
  editedAt_DESC = 'editedAt_DESC',
  estimatedCost_ASC = 'estimatedCost_ASC',
  estimatedCost_DESC = 'estimatedCost_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  instructions_ASC = 'instructions_ASC',
  instructions_DESC = 'instructions_DESC',
  lead_ASC = 'lead_ASC',
  lead_DESC = 'lead_DESC',
  legacyId_ASC = 'legacyId_ASC',
  legacyId_DESC = 'legacyId_DESC',
  lockedAt_ASC = 'lockedAt_ASC',
  lockedAt_DESC = 'lockedAt_DESC',
  lockerId_ASC = 'lockerId_ASC',
  lockerId_DESC = 'lockerId_DESC',
  medias_ASC = 'medias_ASC',
  medias_DESC = 'medias_DESC',
  parsedIngredients_ASC = 'parsedIngredients_ASC',
  parsedIngredients_DESC = 'parsedIngredients_DESC',
  prepTime_ASC = 'prepTime_ASC',
  prepTime_DESC = 'prepTime_DESC',
  publishedAt_ASC = 'publishedAt_ASC',
  publishedAt_DESC = 'publishedAt_DESC',
  rawIngredients_ASC = 'rawIngredients_ASC',
  rawIngredients_DESC = 'rawIngredients_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  source_ASC = 'source_ASC',
  source_DESC = 'source_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  totalTime_ASC = 'totalTime_ASC',
  totalTime_DESC = 'totalTime_DESC',
  unparsedIngredients_ASC = 'unparsedIngredients_ASC',
  unparsedIngredients_DESC = 'unparsedIngredients_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  waitTime_ASC = 'waitTime_ASC',
  waitTime_DESC = 'waitTime_DESC',
  yield_ASC = 'yield_ASC',
  yield_DESC = 'yield_DESC'
}

/** Identifies exactly one "RecipeTag" node. */
export type RecipeTagWhereUniqueInput = {
  id: Scalars['ID']['input'];
};

/** Identifies exactly one "RecipeUrl" node. */
export type RecipeUrlWhereUniqueInput = {
  id: Scalars['ID']['input'];
};

export type TagSuggestionType = {
  __typename?: 'TagSuggestionType';
  tagList: Scalars['String']['output'];
};

/**
 * Identifies exactly one "Tag" node with one of these unique values:
 * - _id
 * - id
 * - slug
 */
export type TagWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum TagOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  slug_ASC = 'slug_ASC',
  slug_DESC = 'slug_DESC',
  title_ASC = 'title_ASC',
  title_DESC = 'title_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * Identifies exactly one "Url" node with one of these unique combinations of values:
 * - _id
 * - id
 * - brandKey, path, publicId
 */
export type UrlWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  brandKey?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
};

export enum UrlOrderByInput {
  _id_ASC = '_id_ASC',
  _id_DESC = '_id_DESC',
  brandKey_ASC = 'brandKey_ASC',
  brandKey_DESC = 'brandKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  path_ASC = 'path_ASC',
  path_DESC = 'path_DESC',
  publicId_ASC = 'publicId_ASC',
  publicId_DESC = 'publicId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/** Identifies exactly one "VoiPublicId" node. */
export type VoiPublicIdWhereUniqueInput = {
  id: Scalars['Int']['input'];
};

/** "VoiPublicId" resource's node */
export type VoiPublicId = {
  __typename?: 'VoiPublicId';
  /** The internal ID */
  id: Scalars['Int']['output'];
  urlId?: Maybe<Scalars['ID']['output']>;
};

/** Filters the "VoiPublicId" nodes by specifying some conditions */
export type VoiPublicIdWhereInput = {
  AND?: InputMaybe<Array<VoiPublicIdWhereInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  id_gt?: InputMaybe<Scalars['Int']['input']>;
  id_gte?: InputMaybe<Scalars['Int']['input']>;
  id_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  id_lt?: InputMaybe<Scalars['Int']['input']>;
  id_lte?: InputMaybe<Scalars['Int']['input']>;
  id_not?: InputMaybe<Scalars['Int']['input']>;
  id_not_in?: InputMaybe<Array<Scalars['Int']['input']>>;
  NOT?: InputMaybe<VoiPublicIdWhereInput>;
  OR?: InputMaybe<Array<VoiPublicIdWhereInput>>;
  urlId?: InputMaybe<Scalars['ID']['input']>;
  urlId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  urlId_is_null?: InputMaybe<Scalars['Boolean']['input']>;
  urlId_not?: InputMaybe<Scalars['ID']['input']>;
  urlId_not_in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export enum VoiPublicIdOrderByInput {
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  urlId_ASC = 'urlId_ASC',
  urlId_DESC = 'urlId_DESC'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Create a single "CacPublicId" node. */
  createCacPublicId: CacPublicId;
  /** Create a single "Category" node. */
  createCategory: Category;
  /** Create a single "CategoryUrl" node. */
  createCategoryUrl: CategoryUrl;
  /** Create a single "FacPublicId" node. */
  createFacPublicId: FacPublicId;
  /** Create a single "Prompt" node. */
  createPrompt: Prompt;
  /** Create a single "Recipe" node. */
  createRecipe: Recipe;
  /** Create a single "RecipeCategory" node. */
  createRecipeCategory: RecipeCategory;
  /** Create a single "RecipeGuide" node. */
  createRecipeGuide: RecipeGuide;
  /** Create a single "RecipeHistory" node. */
  createRecipeHistory: RecipeHistory;
  /** Create a single "RecipeTag" node. */
  createRecipeTag: RecipeTag;
  /** Create a single "RecipeUrl" node. */
  createRecipeUrl: RecipeUrl;
  /** Create a single "Tag" node. */
  createTag: Tag;
  /** Create a single "Url" node. */
  createUrl: Url;
  /** Create a single "VoiPublicId" node. */
  createVoiPublicId: VoiPublicId;
  /** Delete a single "CacPublicId" node. */
  deleteCacPublicId?: Maybe<CacPublicId>;
  /** Delete a single "Category" node. */
  deleteCategory?: Maybe<Category>;
  /** Delete a single "CategoryUrl" node. */
  deleteCategoryUrl?: Maybe<CategoryUrl>;
  /** Delete a single "FacPublicId" node. */
  deleteFacPublicId?: Maybe<FacPublicId>;
  /** Delete a single "Prompt" node. */
  deletePrompt?: Maybe<Prompt>;
  /** Delete a single "Recipe" node. */
  deleteRecipe?: Maybe<Recipe>;
  /** Delete a single "RecipeCategory" node. */
  deleteRecipeCategory?: Maybe<RecipeCategory>;
  /** Delete a single "RecipeGuide" node. */
  deleteRecipeGuide?: Maybe<RecipeGuide>;
  /** Delete a single "RecipeHistory" node. */
  deleteRecipeHistory?: Maybe<RecipeHistory>;
  /** Delete a single "RecipeTag" node. */
  deleteRecipeTag?: Maybe<RecipeTag>;
  /** Delete a single "RecipeUrl" node. */
  deleteRecipeUrl?: Maybe<RecipeUrl>;
  /** Delete a single "Tag" node. */
  deleteTag?: Maybe<Tag>;
  /** Delete a single "Url" node. */
  deleteUrl?: Maybe<Url>;
  /** Delete a single "VoiPublicId" node. */
  deleteVoiPublicId?: Maybe<VoiPublicId>;
  /** Update a single "CacPublicId" node. */
  updateCacPublicId?: Maybe<CacPublicId>;
  /** Update a single "Category" node. */
  updateCategory?: Maybe<Category>;
  /** Update a single "CategoryUrl" node. */
  updateCategoryUrl?: Maybe<CategoryUrl>;
  /** Update a single "FacPublicId" node. */
  updateFacPublicId?: Maybe<FacPublicId>;
  /** Update a single "Prompt" node. */
  updatePrompt?: Maybe<Prompt>;
  /** Update a single "Recipe" node. */
  updateRecipe?: Maybe<Recipe>;
  /** Update authorId of mutiple recipes */
  updateRecipeAuthor: Scalars['Boolean']['output'];
  /** Update a single "RecipeCategory" node. */
  updateRecipeCategory?: Maybe<RecipeCategory>;
  /** Update a single "RecipeGuide" node. */
  updateRecipeGuide?: Maybe<RecipeGuide>;
  /** Update a single "RecipeHistory" node. */
  updateRecipeHistory?: Maybe<RecipeHistory>;
  /** Update a single "RecipeTag" node. */
  updateRecipeTag?: Maybe<RecipeTag>;
  /** Update a single "RecipeUrl" node. */
  updateRecipeUrl?: Maybe<RecipeUrl>;
  /** Update a single "Tag" node. */
  updateTag?: Maybe<Tag>;
  /** Update a single "Url" node. */
  updateUrl?: Maybe<Url>;
  /** Update a single "VoiPublicId" node. */
  updateVoiPublicId?: Maybe<VoiPublicId>;
  /** Update or create a single "CacPublicId" node. */
  upsertCacPublicId: CacPublicId;
  /** Update or create a single "Category" node. */
  upsertCategory: Category;
  /** Update or create a single "CategoryUrl" node. */
  upsertCategoryUrl: CategoryUrl;
  /** Update or create a single "FacPublicId" node. */
  upsertFacPublicId: FacPublicId;
  /** Update or create a single "Prompt" node. */
  upsertPrompt: Prompt;
  /** Update or create a single "Recipe" node. */
  upsertRecipe: Recipe;
  /** Update or create a single "RecipeCategory" node. */
  upsertRecipeCategory: RecipeCategory;
  /** Update or create a single "RecipeGuide" node. */
  upsertRecipeGuide: RecipeGuide;
  /** Update or create a single "RecipeHistory" node. */
  upsertRecipeHistory: RecipeHistory;
  /** Update or create a single "RecipeTag" node. */
  upsertRecipeTag: RecipeTag;
  /** Update or create a single "RecipeUrl" node. */
  upsertRecipeUrl: RecipeUrl;
  /** Update or create a single "Tag" node. */
  upsertTag: Tag;
  /** Update or create a single "Url" node. */
  upsertUrl: Url;
  /** Update or create a single "VoiPublicId" node. */
  upsertVoiPublicId: VoiPublicId;
};


export type MutationCreateCacPublicIdArgs = {
  data: CacPublicIdCreateInput;
};


export type MutationCreateCategoryArgs = {
  data: CategoryCreateInput;
};


export type MutationCreateCategoryUrlArgs = {
  data: CategoryUrlCreateInput;
};


export type MutationCreateFacPublicIdArgs = {
  data: FacPublicIdCreateInput;
};


export type MutationCreatePromptArgs = {
  data: PromptCreateInput;
};


export type MutationCreateRecipeArgs = {
  data: RecipeCreateInput;
};


export type MutationCreateRecipeCategoryArgs = {
  data: RecipeCategoryCreateInput;
};


export type MutationCreateRecipeGuideArgs = {
  data: RecipeGuideCreateInput;
};


export type MutationCreateRecipeHistoryArgs = {
  data: RecipeHistoryCreateInput;
};


export type MutationCreateRecipeTagArgs = {
  data: RecipeTagCreateInput;
};


export type MutationCreateRecipeUrlArgs = {
  data: RecipeUrlCreateInput;
};


export type MutationCreateTagArgs = {
  data: TagCreateInput;
};


export type MutationCreateUrlArgs = {
  data: UrlCreateInput;
};


export type MutationCreateVoiPublicIdArgs = {
  data: VoiPublicIdCreateInput;
};


export type MutationDeleteCacPublicIdArgs = {
  where: CacPublicIdWhereUniqueInput;
};


export type MutationDeleteCategoryArgs = {
  where: CategoryWhereUniqueInput;
};


export type MutationDeleteCategoryUrlArgs = {
  where: CategoryUrlWhereUniqueInput;
};


export type MutationDeleteFacPublicIdArgs = {
  where: FacPublicIdWhereUniqueInput;
};


export type MutationDeletePromptArgs = {
  where: PromptWhereUniqueInput;
};


export type MutationDeleteRecipeArgs = {
  where: RecipeWhereUniqueInput;
};


export type MutationDeleteRecipeCategoryArgs = {
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationDeleteRecipeGuideArgs = {
  where: RecipeGuideWhereUniqueInput;
};


export type MutationDeleteRecipeHistoryArgs = {
  where: RecipeHistoryWhereUniqueInput;
};


export type MutationDeleteRecipeTagArgs = {
  where: RecipeTagWhereUniqueInput;
};


export type MutationDeleteRecipeUrlArgs = {
  where: RecipeUrlWhereUniqueInput;
};


export type MutationDeleteTagArgs = {
  where: TagWhereUniqueInput;
};


export type MutationDeleteUrlArgs = {
  where: UrlWhereUniqueInput;
};


export type MutationDeleteVoiPublicIdArgs = {
  where: VoiPublicIdWhereUniqueInput;
};


export type MutationUpdateCacPublicIdArgs = {
  data: CacPublicIdUpdateInput;
  where: CacPublicIdWhereUniqueInput;
};


export type MutationUpdateCategoryArgs = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpdateCategoryUrlArgs = {
  data: CategoryUrlUpdateInput;
  where: CategoryUrlWhereUniqueInput;
};


export type MutationUpdateFacPublicIdArgs = {
  data: FacPublicIdUpdateInput;
  where: FacPublicIdWhereUniqueInput;
};


export type MutationUpdatePromptArgs = {
  data: PromptUpdateInput;
  where: PromptWhereUniqueInput;
};


export type MutationUpdateRecipeArgs = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};


export type MutationUpdateRecipeAuthorArgs = {
  brandKey: BrandKey;
  newAuthorId: Scalars['String']['input'];
  originalAuthorId: Scalars['String']['input'];
};


export type MutationUpdateRecipeCategoryArgs = {
  data: RecipeCategoryUpdateInput;
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationUpdateRecipeGuideArgs = {
  data: RecipeGuideUpdateInput;
  where: RecipeGuideWhereUniqueInput;
};


export type MutationUpdateRecipeHistoryArgs = {
  data: RecipeHistoryUpdateInput;
  where: RecipeHistoryWhereUniqueInput;
};


export type MutationUpdateRecipeTagArgs = {
  data: RecipeTagUpdateInput;
  where: RecipeTagWhereUniqueInput;
};


export type MutationUpdateRecipeUrlArgs = {
  data: RecipeUrlUpdateInput;
  where: RecipeUrlWhereUniqueInput;
};


export type MutationUpdateTagArgs = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};


export type MutationUpdateUrlArgs = {
  data: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};


export type MutationUpdateVoiPublicIdArgs = {
  data: VoiPublicIdUpdateInput;
  where: VoiPublicIdWhereUniqueInput;
};


export type MutationUpsertCacPublicIdArgs = {
  create: CacPublicIdCreateInput;
  update: CacPublicIdUpdateInput;
  where: CacPublicIdWhereUniqueInput;
};


export type MutationUpsertCategoryArgs = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};


export type MutationUpsertCategoryUrlArgs = {
  create: CategoryUrlCreateInput;
  update: CategoryUrlUpdateInput;
  where: CategoryUrlWhereUniqueInput;
};


export type MutationUpsertFacPublicIdArgs = {
  create: FacPublicIdCreateInput;
  update: FacPublicIdUpdateInput;
  where: FacPublicIdWhereUniqueInput;
};


export type MutationUpsertPromptArgs = {
  create: PromptCreateInput;
  update: PromptUpdateInput;
  where: PromptWhereUniqueInput;
};


export type MutationUpsertRecipeArgs = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};


export type MutationUpsertRecipeCategoryArgs = {
  create: RecipeCategoryCreateInput;
  update: RecipeCategoryUpdateInput;
  where: RecipeCategoryWhereUniqueInput;
};


export type MutationUpsertRecipeGuideArgs = {
  create: RecipeGuideCreateInput;
  update: RecipeGuideUpdateInput;
  where: RecipeGuideWhereUniqueInput;
};


export type MutationUpsertRecipeHistoryArgs = {
  create: RecipeHistoryCreateInput;
  update: RecipeHistoryUpdateInput;
  where: RecipeHistoryWhereUniqueInput;
};


export type MutationUpsertRecipeTagArgs = {
  create: RecipeTagCreateInput;
  update: RecipeTagUpdateInput;
  where: RecipeTagWhereUniqueInput;
};


export type MutationUpsertRecipeUrlArgs = {
  create: RecipeUrlCreateInput;
  update: RecipeUrlUpdateInput;
  where: RecipeUrlWhereUniqueInput;
};


export type MutationUpsertTagArgs = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};


export type MutationUpsertUrlArgs = {
  create: UrlCreateInput;
  update: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};


export type MutationUpsertVoiPublicIdArgs = {
  create: VoiPublicIdCreateInput;
  update: VoiPublicIdUpdateInput;
  where: VoiPublicIdWhereUniqueInput;
};

export type CacPublicIdCreateInput = {
  urlId?: InputMaybe<Scalars['ID']['input']>;
};

export type CategoryCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  brandKey: Scalars['String']['input'];
  /** Actions for the "Category.categoryUrls" relation: "CategoryUrl.category"'s inverse relation */
  categoryUrls?: InputMaybe<CategoryNestedCategoryUrlsCreateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  left: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
  medias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.parent" relation */
  parent?: InputMaybe<CategoryNestedParentCreateInput>;
  /** Actions for the "Category.recipeCategories" relation: "RecipeCategory.category"'s inverse relation */
  recipeCategories?: InputMaybe<CategoryNestedRecipeCategoriesCreateInput>;
  right: Scalars['Int']['input'];
  rootId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CategoryNestedCategoryUrlsCreateInput = {
  /** Connect existing "CategoryUrl" nodes to the new "Category" node, through the "Category.categoryUrls" relation. */
  connect?: InputMaybe<Array<CategoryUrlWhereUniqueInput>>;
  /** Create new "CategoryUrl" nodes and connect them to the new "Category" node, through the "Category.categoryUrls" relation. */
  create?: InputMaybe<Array<CategoryUrlWithForcedCategoryCreateInput>>;
};

export type CategoryUrlWithForcedCategoryCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  /** Actions for the "CategoryUrl.url" relation */
  url?: InputMaybe<CategoryUrlNestedUrlCreateInput>;
};

export type CategoryUrlNestedUrlCreateInput = {
  /** Connect an existing "Url" node to the new "CategoryUrl" node, through the "CategoryUrl.url" relation. */
  connect?: InputMaybe<UrlWhereUniqueInput>;
  /** Create a new "Url" node and connect it to the new "CategoryUrl" node, through the "CategoryUrl.url" relation. */
  create?: InputMaybe<UrlCreateInput>;
  /** Update an existing "Url" node and connect it to the new "CategoryUrl" node, through the "CategoryUrl.url" relation. */
  update?: InputMaybe<CategoryUrlNestedUpdateUrlCreateInput>;
  /** Create or update a "Url" node and connect it to the new "CategoryUrl" node, through the "CategoryUrl.url" relation. */
  upsert?: InputMaybe<CategoryUrlNestedUpsertUrlCreateInput>;
};

export type UrlCreateInput = {
  brandKey?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Url.categoryUrls" relation: "CategoryUrl.url"'s inverse relation */
  categoryUrls?: InputMaybe<UrlNestedCategoryUrlsCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  path: Scalars['String']['input'];
  publicId?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Url.recipeUrls" relation: "RecipeUrl.url"'s inverse relation */
  recipeUrls?: InputMaybe<UrlNestedRecipeUrlsCreateInput>;
};

export type UrlNestedCategoryUrlsCreateInput = {
  /** Connect existing "CategoryUrl" nodes to the new "Url" node, through the "Url.categoryUrls" relation. */
  connect?: InputMaybe<Array<CategoryUrlWhereUniqueInput>>;
  /** Create new "CategoryUrl" nodes and connect them to the new "Url" node, through the "Url.categoryUrls" relation. */
  create?: InputMaybe<Array<CategoryUrlWithForcedUrlCreateInput>>;
};

export type CategoryUrlWithForcedUrlCreateInput = {
  /** Actions for the "CategoryUrl.category" relation */
  category?: InputMaybe<CategoryUrlNestedCategoryCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
};

export type CategoryUrlNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "CategoryUrl" node, through the "CategoryUrl.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "CategoryUrl" node, through the "CategoryUrl.category" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /**
   * Update an existing "Category" node and connect it to the new "CategoryUrl"
   * node, through the "CategoryUrl.category" relation.
   */
  update?: InputMaybe<CategoryUrlNestedUpdateCategoryCreateInput>;
  /**
   * Create or update a "Category" node and connect it to the new "CategoryUrl"
   * node, through the "CategoryUrl.category" relation.
   */
  upsert?: InputMaybe<CategoryUrlNestedUpsertCategoryCreateInput>;
};

export type CategoryUrlNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.categoryUrls" relation: "CategoryUrl.category"'s inverse relation */
  categoryUrls?: InputMaybe<CategoryNestedCategoryUrlsUpdateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenUpdateInput>;
  left?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.parent" relation */
  parent?: InputMaybe<CategoryNestedParentUpdateInput>;
  /** Actions for the "Category.recipeCategories" relation: "RecipeCategory.category"'s inverse relation */
  recipeCategories?: InputMaybe<CategoryNestedRecipeCategoriesUpdateInput>;
  right?: InputMaybe<Scalars['Int']['input']>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryNestedCategoryUrlsUpdateInput = {
  /** Connect existing "CategoryUrl" nodes to the existing "Category" node, through the "Category.categoryUrls" relation. */
  connect?: InputMaybe<Array<CategoryUrlWhereUniqueInput>>;
  /**
   * Create new "CategoryUrl" nodes and connect them to the existing "Category"
   * node, through the "Category.categoryUrls" relation.
   */
  create?: InputMaybe<Array<CategoryUrlWithForcedCategoryCreateInput>>;
  /** Delete existing "CategoryUrl" nodes from the "Category.categoryUrls" relation. */
  delete?: InputMaybe<Array<CategoryUrlWhereUniqueInput>>;
  /** Disconnect existing "CategoryUrl" nodes of the "Category.categoryUrls" relation. */
  disconnect?: InputMaybe<Array<CategoryUrlWhereUniqueInput>>;
  /**
   * Update existing "CategoryUrl" nodes and connect them to the existing
   * "Category" node, through the "Category.categoryUrls" relation.
   */
  update?: InputMaybe<Array<CategoryNestedUpdateCategoryUrlsUpdateInput>>;
  /**
   * Upsert existing "CategoryUrl" nodes and connect them to the existing
   * "Category" node, through the "Category.categoryUrls" relation.
   */
  upsert?: InputMaybe<Array<CategoryNestedUpsertCategoryUrlsUpdateInput>>;
};

export type CategoryNestedUpdateCategoryUrlsUpdateInput = {
  data: CategoryUrlWithForcedCategoryUpdateInput;
  where: CategoryUrlWhereUniqueInput;
};

export type CategoryUrlWithForcedCategoryUpdateInput = {
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "CategoryUrl.url" relation */
  url?: InputMaybe<CategoryUrlNestedUrlUpdateInput>;
};

export type CategoryUrlNestedUrlUpdateInput = {
  /** Connect an existing "Url" node to the existing "CategoryUrl" node, through the "CategoryUrl.url" relation. */
  connect?: InputMaybe<UrlWhereUniqueInput>;
  /** Create a new "Url" node and connect it to the existing "CategoryUrl" node, through the "CategoryUrl.url" relation. */
  create?: InputMaybe<UrlCreateInput>;
  /** Disconnect the current connected "Url" node, if any, of the "CategoryUrl.url" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Url" node and connect it to the existing "CategoryUrl" node, through the "CategoryUrl.url" relation. */
  update?: InputMaybe<CategoryUrlNestedUpdateUrlUpdateInput>;
  /** Create or update a "Url" node and connect it to the existing "CategoryUrl" node, through the "CategoryUrl.url" relation. */
  upsert?: InputMaybe<CategoryUrlNestedUpsertUrlUpdateInput>;
};

export type CategoryUrlNestedUpdateUrlUpdateInput = {
  data: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};

export type UrlUpdateInput = {
  brandKey?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Url.categoryUrls" relation: "CategoryUrl.url"'s inverse relation */
  categoryUrls?: InputMaybe<UrlNestedCategoryUrlsUpdateInput>;
  path?: InputMaybe<Scalars['String']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Url.recipeUrls" relation: "RecipeUrl.url"'s inverse relation */
  recipeUrls?: InputMaybe<UrlNestedRecipeUrlsUpdateInput>;
};

export type UrlNestedCategoryUrlsUpdateInput = {
  /** Connect existing "CategoryUrl" nodes to the existing "Url" node, through the "Url.categoryUrls" relation. */
  connect?: InputMaybe<Array<CategoryUrlWhereUniqueInput>>;
  /** Create new "CategoryUrl" nodes and connect them to the existing "Url" node, through the "Url.categoryUrls" relation. */
  create?: InputMaybe<Array<CategoryUrlWithForcedUrlCreateInput>>;
  /** Delete existing "CategoryUrl" nodes from the "Url.categoryUrls" relation. */
  delete?: InputMaybe<Array<CategoryUrlWhereUniqueInput>>;
  /** Disconnect existing "CategoryUrl" nodes of the "Url.categoryUrls" relation. */
  disconnect?: InputMaybe<Array<CategoryUrlWhereUniqueInput>>;
  /** Update existing "CategoryUrl" nodes and connect them to the existing "Url" node, through the "Url.categoryUrls" relation. */
  update?: InputMaybe<Array<UrlNestedUpdateCategoryUrlsUpdateInput>>;
  /** Upsert existing "CategoryUrl" nodes and connect them to the existing "Url" node, through the "Url.categoryUrls" relation. */
  upsert?: InputMaybe<Array<UrlNestedUpsertCategoryUrlsUpdateInput>>;
};

export type UrlNestedUpdateCategoryUrlsUpdateInput = {
  data: CategoryUrlWithForcedUrlUpdateInput;
  where: CategoryUrlWhereUniqueInput;
};

export type CategoryUrlWithForcedUrlUpdateInput = {
  /** Actions for the "CategoryUrl.category" relation */
  category?: InputMaybe<CategoryUrlNestedCategoryUpdateInput>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryUrlNestedCategoryUpdateInput = {
  /** Connect an existing "Category" node to the existing "CategoryUrl" node, through the "CategoryUrl.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /**
   * Create a new "Category" node and connect it to the existing "CategoryUrl"
   * node, through the "CategoryUrl.category" relation.
   */
  create?: InputMaybe<CategoryCreateInput>;
  /** Disconnect the current connected "Category" node, if any, of the "CategoryUrl.category" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update an existing "Category" node and connect it to the existing
   * "CategoryUrl" node, through the "CategoryUrl.category" relation.
   */
  update?: InputMaybe<CategoryUrlNestedUpdateCategoryUpdateInput>;
  /**
   * Create or update a "Category" node and connect it to the existing
   * "CategoryUrl" node, through the "CategoryUrl.category" relation.
   */
  upsert?: InputMaybe<CategoryUrlNestedUpsertCategoryUpdateInput>;
};

export type CategoryUrlNestedUpdateCategoryUpdateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUrlNestedUpsertCategoryUpdateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type UrlNestedUpsertCategoryUrlsUpdateInput = {
  create: CategoryUrlWithForcedUrlCreateInput;
  update: CategoryUrlWithForcedUrlUpdateInput;
  where: CategoryUrlWhereUniqueInput;
};

export type UrlNestedRecipeUrlsUpdateInput = {
  /** Connect existing "RecipeUrl" nodes to the existing "Url" node, through the "Url.recipeUrls" relation. */
  connect?: InputMaybe<Array<RecipeUrlWhereUniqueInput>>;
  /** Create new "RecipeUrl" nodes and connect them to the existing "Url" node, through the "Url.recipeUrls" relation. */
  create?: InputMaybe<Array<RecipeUrlWithForcedUrlCreateInput>>;
  /** Delete existing "RecipeUrl" nodes from the "Url.recipeUrls" relation. */
  delete?: InputMaybe<Array<RecipeUrlWhereUniqueInput>>;
  /** Disconnect existing "RecipeUrl" nodes of the "Url.recipeUrls" relation. */
  disconnect?: InputMaybe<Array<RecipeUrlWhereUniqueInput>>;
  /** Update existing "RecipeUrl" nodes and connect them to the existing "Url" node, through the "Url.recipeUrls" relation. */
  update?: InputMaybe<Array<UrlNestedUpdateRecipeUrlsUpdateInput>>;
  /** Upsert existing "RecipeUrl" nodes and connect them to the existing "Url" node, through the "Url.recipeUrls" relation. */
  upsert?: InputMaybe<Array<UrlNestedUpsertRecipeUrlsUpdateInput>>;
};

export type RecipeUrlWithForcedUrlCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  /** Actions for the "RecipeUrl.recipe" relation */
  recipe?: InputMaybe<RecipeUrlNestedRecipeCreateInput>;
};

export type RecipeUrlNestedRecipeCreateInput = {
  /** Connect an existing "Recipe" node to the new "RecipeUrl" node, through the "RecipeUrl.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create a new "Recipe" node and connect it to the new "RecipeUrl" node, through the "RecipeUrl.recipe" relation. */
  create?: InputMaybe<RecipeCreateInput>;
  /** Update an existing "Recipe" node and connect it to the new "RecipeUrl" node, through the "RecipeUrl.recipe" relation. */
  update?: InputMaybe<RecipeUrlNestedUpdateRecipeCreateInput>;
  /** Create or update a "Recipe" node and connect it to the new "RecipeUrl" node, through the "RecipeUrl.recipe" relation. */
  upsert?: InputMaybe<RecipeUrlNestedUpsertRecipeCreateInput>;
};

export type RecipeCreateInput = {
  advice?: InputMaybe<Scalars['String']['input']>;
  /** Represents the list of fields generated by AI in the front application before saving the recipe */
  aiGenerated?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  brandKey: Scalars['String']['input'];
  calorieLevel?: InputMaybe<Scalars['String']['input']>;
  cookingMethod?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedCost?: InputMaybe<Scalars['String']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients: Scalars['String']['input'];
  prepTime?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the document's publication */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rawIngredients: Scalars['String']['input'];
  /** Actions for the "Recipe.recipeCategories" relation: "RecipeCategory.recipe"'s inverse relation */
  recipeCategories?: InputMaybe<RecipeNestedRecipeCategoriesCreateInput>;
  /** Actions for the "Recipe.recipeGuides" relation: "RecipeGuide.recipe"'s inverse relation */
  recipeGuides?: InputMaybe<RecipeNestedRecipeGuidesCreateInput>;
  /** Actions for the "Recipe.recipeHistories" relation: "RecipeHistory.recipe"'s inverse relation */
  recipeHistories?: InputMaybe<RecipeNestedRecipeHistoriesCreateInput>;
  /** Actions for the "Recipe.recipeTags" relation: "RecipeTag.recipe"'s inverse relation */
  recipeTags?: InputMaybe<RecipeNestedRecipeTagsCreateInput>;
  /** Actions for the "Recipe.recipeUrls" relation: "RecipeUrl.recipe"'s inverse relation */
  recipeUrls?: InputMaybe<RecipeNestedRecipeUrlsCreateInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RecipeStatus>;
  title: Scalars['String']['input'];
  totalTime?: InputMaybe<Scalars['Int']['input']>;
  unparsedIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  waitTime?: InputMaybe<Scalars['Int']['input']>;
  yield?: InputMaybe<Scalars['Int']['input']>;
};

export type RecipeNestedRecipeCategoriesCreateInput = {
  /** Connect existing "RecipeCategory" nodes to the new "Recipe" node, through the "Recipe.recipeCategories" relation. */
  connect?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /**
   * Create new "RecipeCategory" nodes and connect them to the new "Recipe" node,
   * through the "Recipe.recipeCategories" relation.
   */
  create?: InputMaybe<Array<RecipeCategoryWithForcedRecipeCreateInput>>;
};

export type RecipeCategoryWithForcedRecipeCreateInput = {
  /** Actions for the "RecipeCategory.category" relation */
  category?: InputMaybe<RecipeCategoryNestedCategoryCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
};

export type RecipeCategoryNestedCategoryCreateInput = {
  /** Connect an existing "Category" node to the new "RecipeCategory" node, through the "RecipeCategory.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /**
   * Create a new "Category" node and connect it to the new "RecipeCategory" node,
   * through the "RecipeCategory.category" relation.
   */
  create?: InputMaybe<CategoryCreateInput>;
  /**
   * Update an existing "Category" node and connect it to the new "RecipeCategory"
   * node, through the "RecipeCategory.category" relation.
   */
  update?: InputMaybe<RecipeCategoryNestedUpdateCategoryCreateInput>;
  /**
   * Create or update a "Category" node and connect it to the new "RecipeCategory"
   * node, through the "RecipeCategory.category" relation.
   */
  upsert?: InputMaybe<RecipeCategoryNestedUpsertCategoryCreateInput>;
};

export type RecipeCategoryNestedUpdateCategoryCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type RecipeCategoryNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type RecipeNestedRecipeGuidesCreateInput = {
  /** Connect existing "RecipeGuide" nodes to the new "Recipe" node, through the "Recipe.recipeGuides" relation. */
  connect?: InputMaybe<Array<RecipeGuideWhereUniqueInput>>;
  /** Create new "RecipeGuide" nodes and connect them to the new "Recipe" node, through the "Recipe.recipeGuides" relation. */
  create?: InputMaybe<Array<RecipeGuideWithForcedRecipeCreateInput>>;
};

export type RecipeGuideWithForcedRecipeCreateInput = {
  guideId?: InputMaybe<Scalars['ID']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
};

export type RecipeNestedRecipeHistoriesCreateInput = {
  /** Connect existing "RecipeHistory" nodes to the new "Recipe" node, through the "Recipe.recipeHistories" relation. */
  connect?: InputMaybe<Array<RecipeHistoryWhereUniqueInput>>;
  /** Create new "RecipeHistory" nodes and connect them to the new "Recipe" node, through the "Recipe.recipeHistories" relation. */
  create?: InputMaybe<Array<RecipeHistoryWithForcedRecipeCreateInput>>;
};

export type RecipeHistoryWithForcedRecipeCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<RecipeStatus>;
};

export type RecipeNestedRecipeTagsCreateInput = {
  /** Connect existing "RecipeTag" nodes to the new "Recipe" node, through the "Recipe.recipeTags" relation. */
  connect?: InputMaybe<Array<RecipeTagWhereUniqueInput>>;
  /** Create new "RecipeTag" nodes and connect them to the new "Recipe" node, through the "Recipe.recipeTags" relation. */
  create?: InputMaybe<Array<RecipeTagWithForcedRecipeCreateInput>>;
};

export type RecipeTagWithForcedRecipeCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "RecipeTag.tag" relation */
  tag?: InputMaybe<RecipeTagNestedTagCreateInput>;
};

export type RecipeTagNestedTagCreateInput = {
  /** Connect an existing "Tag" node to the new "RecipeTag" node, through the "RecipeTag.tag" relation. */
  connect?: InputMaybe<TagWhereUniqueInput>;
  /** Create a new "Tag" node and connect it to the new "RecipeTag" node, through the "RecipeTag.tag" relation. */
  create?: InputMaybe<TagCreateInput>;
  /** Update an existing "Tag" node and connect it to the new "RecipeTag" node, through the "RecipeTag.tag" relation. */
  update?: InputMaybe<RecipeTagNestedUpdateTagCreateInput>;
  /** Create or update a "Tag" node and connect it to the new "RecipeTag" node, through the "RecipeTag.tag" relation. */
  upsert?: InputMaybe<RecipeTagNestedUpsertTagCreateInput>;
};

export type TagCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "Tag.recipeTags" relation: "RecipeTag.tag"'s inverse relation */
  recipeTags?: InputMaybe<TagNestedRecipeTagsCreateInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type TagNestedRecipeTagsCreateInput = {
  /** Connect existing "RecipeTag" nodes to the new "Tag" node, through the "Tag.recipeTags" relation. */
  connect?: InputMaybe<Array<RecipeTagWhereUniqueInput>>;
  /** Create new "RecipeTag" nodes and connect them to the new "Tag" node, through the "Tag.recipeTags" relation. */
  create?: InputMaybe<Array<RecipeTagWithForcedTagCreateInput>>;
};

export type RecipeTagWithForcedTagCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "RecipeTag.recipe" relation */
  recipe?: InputMaybe<RecipeTagNestedRecipeCreateInput>;
};

export type RecipeTagNestedRecipeCreateInput = {
  /** Connect an existing "Recipe" node to the new "RecipeTag" node, through the "RecipeTag.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create a new "Recipe" node and connect it to the new "RecipeTag" node, through the "RecipeTag.recipe" relation. */
  create?: InputMaybe<RecipeCreateInput>;
  /** Update an existing "Recipe" node and connect it to the new "RecipeTag" node, through the "RecipeTag.recipe" relation. */
  update?: InputMaybe<RecipeTagNestedUpdateRecipeCreateInput>;
  /** Create or update a "Recipe" node and connect it to the new "RecipeTag" node, through the "RecipeTag.recipe" relation. */
  upsert?: InputMaybe<RecipeTagNestedUpsertRecipeCreateInput>;
};

export type RecipeTagNestedUpdateRecipeCreateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeUpdateInput = {
  advice?: InputMaybe<Scalars['String']['input']>;
  /** Represents the list of fields generated by AI in the front application before saving the recipe */
  aiGenerated?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['ID']['input']>;
  brandKey?: InputMaybe<Scalars['String']['input']>;
  calorieLevel?: InputMaybe<Scalars['String']['input']>;
  cookingMethod?: InputMaybe<Scalars['String']['input']>;
  cookTime?: InputMaybe<Scalars['Int']['input']>;
  creatorId?: InputMaybe<Scalars['ID']['input']>;
  difficulty?: InputMaybe<Scalars['String']['input']>;
  editedAt?: InputMaybe<Scalars['DateTime']['input']>;
  estimatedCost?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  lead?: InputMaybe<Scalars['String']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  lockerId?: InputMaybe<Scalars['ID']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  parsedIngredients?: InputMaybe<Scalars['String']['input']>;
  prepTime?: InputMaybe<Scalars['Int']['input']>;
  /** The date of the document's publication */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rawIngredients?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Recipe.recipeCategories" relation: "RecipeCategory.recipe"'s inverse relation */
  recipeCategories?: InputMaybe<RecipeNestedRecipeCategoriesUpdateInput>;
  /** Actions for the "Recipe.recipeGuides" relation: "RecipeGuide.recipe"'s inverse relation */
  recipeGuides?: InputMaybe<RecipeNestedRecipeGuidesUpdateInput>;
  /** Actions for the "Recipe.recipeHistories" relation: "RecipeHistory.recipe"'s inverse relation */
  recipeHistories?: InputMaybe<RecipeNestedRecipeHistoriesUpdateInput>;
  /** Actions for the "Recipe.recipeTags" relation: "RecipeTag.recipe"'s inverse relation */
  recipeTags?: InputMaybe<RecipeNestedRecipeTagsUpdateInput>;
  /** Actions for the "Recipe.recipeUrls" relation: "RecipeUrl.recipe"'s inverse relation */
  recipeUrls?: InputMaybe<RecipeNestedRecipeUrlsUpdateInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<RecipeStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalTime?: InputMaybe<Scalars['Int']['input']>;
  unparsedIngredients?: InputMaybe<Scalars['Boolean']['input']>;
  waitTime?: InputMaybe<Scalars['Int']['input']>;
  yield?: InputMaybe<Scalars['Int']['input']>;
};

export type RecipeNestedRecipeCategoriesUpdateInput = {
  /** Connect existing "RecipeCategory" nodes to the existing "Recipe" node, through the "Recipe.recipeCategories" relation. */
  connect?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /**
   * Create new "RecipeCategory" nodes and connect them to the existing "Recipe"
   * node, through the "Recipe.recipeCategories" relation.
   */
  create?: InputMaybe<Array<RecipeCategoryWithForcedRecipeCreateInput>>;
  /** Delete existing "RecipeCategory" nodes from the "Recipe.recipeCategories" relation. */
  delete?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /** Disconnect existing "RecipeCategory" nodes of the "Recipe.recipeCategories" relation. */
  disconnect?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /**
   * Update existing "RecipeCategory" nodes and connect them to the existing
   * "Recipe" node, through the "Recipe.recipeCategories" relation.
   */
  update?: InputMaybe<Array<RecipeNestedUpdateRecipeCategoriesUpdateInput>>;
  /**
   * Upsert existing "RecipeCategory" nodes and connect them to the existing
   * "Recipe" node, through the "Recipe.recipeCategories" relation.
   */
  upsert?: InputMaybe<Array<RecipeNestedUpsertRecipeCategoriesUpdateInput>>;
};

export type RecipeNestedUpdateRecipeCategoriesUpdateInput = {
  data: RecipeCategoryWithForcedRecipeUpdateInput;
  where: RecipeCategoryWhereUniqueInput;
};

export type RecipeCategoryWithForcedRecipeUpdateInput = {
  /** Actions for the "RecipeCategory.category" relation */
  category?: InputMaybe<RecipeCategoryNestedCategoryUpdateInput>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type RecipeCategoryNestedCategoryUpdateInput = {
  /** Connect an existing "Category" node to the existing "RecipeCategory" node, through the "RecipeCategory.category" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /**
   * Create a new "Category" node and connect it to the existing "RecipeCategory"
   * node, through the "RecipeCategory.category" relation.
   */
  create?: InputMaybe<CategoryCreateInput>;
  /** Disconnect the current connected "Category" node, if any, of the "RecipeCategory.category" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update an existing "Category" node and connect it to the existing
   * "RecipeCategory" node, through the "RecipeCategory.category" relation.
   */
  update?: InputMaybe<RecipeCategoryNestedUpdateCategoryUpdateInput>;
  /**
   * Create or update a "Category" node and connect it to the existing
   * "RecipeCategory" node, through the "RecipeCategory.category" relation.
   */
  upsert?: InputMaybe<RecipeCategoryNestedUpsertCategoryUpdateInput>;
};

export type RecipeCategoryNestedUpdateCategoryUpdateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type RecipeCategoryNestedUpsertCategoryUpdateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type RecipeNestedUpsertRecipeCategoriesUpdateInput = {
  create: RecipeCategoryWithForcedRecipeCreateInput;
  update: RecipeCategoryWithForcedRecipeUpdateInput;
  where: RecipeCategoryWhereUniqueInput;
};

export type RecipeNestedRecipeGuidesUpdateInput = {
  /** Connect existing "RecipeGuide" nodes to the existing "Recipe" node, through the "Recipe.recipeGuides" relation. */
  connect?: InputMaybe<Array<RecipeGuideWhereUniqueInput>>;
  /** Create new "RecipeGuide" nodes and connect them to the existing "Recipe" node, through the "Recipe.recipeGuides" relation. */
  create?: InputMaybe<Array<RecipeGuideWithForcedRecipeCreateInput>>;
  /** Delete existing "RecipeGuide" nodes from the "Recipe.recipeGuides" relation. */
  delete?: InputMaybe<Array<RecipeGuideWhereUniqueInput>>;
  /** Disconnect existing "RecipeGuide" nodes of the "Recipe.recipeGuides" relation. */
  disconnect?: InputMaybe<Array<RecipeGuideWhereUniqueInput>>;
  /**
   * Update existing "RecipeGuide" nodes and connect them to the existing "Recipe"
   * node, through the "Recipe.recipeGuides" relation.
   */
  update?: InputMaybe<Array<RecipeNestedUpdateRecipeGuidesUpdateInput>>;
  /**
   * Upsert existing "RecipeGuide" nodes and connect them to the existing "Recipe"
   * node, through the "Recipe.recipeGuides" relation.
   */
  upsert?: InputMaybe<Array<RecipeNestedUpsertRecipeGuidesUpdateInput>>;
};

export type RecipeNestedUpdateRecipeGuidesUpdateInput = {
  data: RecipeGuideWithForcedRecipeUpdateInput;
  where: RecipeGuideWhereUniqueInput;
};

export type RecipeGuideWithForcedRecipeUpdateInput = {
  guideId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type RecipeNestedUpsertRecipeGuidesUpdateInput = {
  create: RecipeGuideWithForcedRecipeCreateInput;
  update: RecipeGuideWithForcedRecipeUpdateInput;
  where: RecipeGuideWhereUniqueInput;
};

export type RecipeNestedRecipeHistoriesUpdateInput = {
  /** Connect existing "RecipeHistory" nodes to the existing "Recipe" node, through the "Recipe.recipeHistories" relation. */
  connect?: InputMaybe<Array<RecipeHistoryWhereUniqueInput>>;
  /**
   * Create new "RecipeHistory" nodes and connect them to the existing "Recipe"
   * node, through the "Recipe.recipeHistories" relation.
   */
  create?: InputMaybe<Array<RecipeHistoryWithForcedRecipeCreateInput>>;
  /** Delete existing "RecipeHistory" nodes from the "Recipe.recipeHistories" relation. */
  delete?: InputMaybe<Array<RecipeHistoryWhereUniqueInput>>;
  /**
   * Update existing "RecipeHistory" nodes and connect them to the existing
   * "Recipe" node, through the "Recipe.recipeHistories" relation.
   */
  update?: InputMaybe<Array<RecipeNestedUpdateRecipeHistoriesUpdateInput>>;
  /**
   * Upsert existing "RecipeHistory" nodes and connect them to the existing
   * "Recipe" node, through the "Recipe.recipeHistories" relation.
   */
  upsert?: InputMaybe<Array<RecipeNestedUpsertRecipeHistoriesUpdateInput>>;
};

export type RecipeNestedUpdateRecipeHistoriesUpdateInput = {
  data: RecipeHistoryWithForcedRecipeUpdateInput;
  where: RecipeHistoryWhereUniqueInput;
};

export type RecipeHistoryWithForcedRecipeUpdateInput = {
  status?: InputMaybe<RecipeStatus>;
};

export type RecipeNestedUpsertRecipeHistoriesUpdateInput = {
  create: RecipeHistoryWithForcedRecipeCreateInput;
  update: RecipeHistoryWithForcedRecipeUpdateInput;
  where: RecipeHistoryWhereUniqueInput;
};

export type RecipeNestedRecipeTagsUpdateInput = {
  /** Connect existing "RecipeTag" nodes to the existing "Recipe" node, through the "Recipe.recipeTags" relation. */
  connect?: InputMaybe<Array<RecipeTagWhereUniqueInput>>;
  /** Create new "RecipeTag" nodes and connect them to the existing "Recipe" node, through the "Recipe.recipeTags" relation. */
  create?: InputMaybe<Array<RecipeTagWithForcedRecipeCreateInput>>;
  /** Delete existing "RecipeTag" nodes from the "Recipe.recipeTags" relation. */
  delete?: InputMaybe<Array<RecipeTagWhereUniqueInput>>;
  /** Disconnect existing "RecipeTag" nodes of the "Recipe.recipeTags" relation. */
  disconnect?: InputMaybe<Array<RecipeTagWhereUniqueInput>>;
  /**
   * Update existing "RecipeTag" nodes and connect them to the existing "Recipe"
   * node, through the "Recipe.recipeTags" relation.
   */
  update?: InputMaybe<Array<RecipeNestedUpdateRecipeTagsUpdateInput>>;
  /**
   * Upsert existing "RecipeTag" nodes and connect them to the existing "Recipe"
   * node, through the "Recipe.recipeTags" relation.
   */
  upsert?: InputMaybe<Array<RecipeNestedUpsertRecipeTagsUpdateInput>>;
};

export type RecipeNestedUpdateRecipeTagsUpdateInput = {
  data: RecipeTagWithForcedRecipeUpdateInput;
  where: RecipeTagWhereUniqueInput;
};

export type RecipeTagWithForcedRecipeUpdateInput = {
  /** Actions for the "RecipeTag.tag" relation */
  tag?: InputMaybe<RecipeTagNestedTagUpdateInput>;
};

export type RecipeTagNestedTagUpdateInput = {
  /** Connect an existing "Tag" node to the existing "RecipeTag" node, through the "RecipeTag.tag" relation. */
  connect?: InputMaybe<TagWhereUniqueInput>;
  /** Create a new "Tag" node and connect it to the existing "RecipeTag" node, through the "RecipeTag.tag" relation. */
  create?: InputMaybe<TagCreateInput>;
  /** Disconnect the current connected "Tag" node, if any, of the "RecipeTag.tag" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Tag" node and connect it to the existing "RecipeTag" node, through the "RecipeTag.tag" relation. */
  update?: InputMaybe<RecipeTagNestedUpdateTagUpdateInput>;
  /** Create or update a "Tag" node and connect it to the existing "RecipeTag" node, through the "RecipeTag.tag" relation. */
  upsert?: InputMaybe<RecipeTagNestedUpsertTagUpdateInput>;
};

export type RecipeTagNestedUpdateTagUpdateInput = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type TagUpdateInput = {
  /** Actions for the "Tag.recipeTags" relation: "RecipeTag.tag"'s inverse relation */
  recipeTags?: InputMaybe<TagNestedRecipeTagsUpdateInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TagNestedRecipeTagsUpdateInput = {
  /** Connect existing "RecipeTag" nodes to the existing "Tag" node, through the "Tag.recipeTags" relation. */
  connect?: InputMaybe<Array<RecipeTagWhereUniqueInput>>;
  /** Create new "RecipeTag" nodes and connect them to the existing "Tag" node, through the "Tag.recipeTags" relation. */
  create?: InputMaybe<Array<RecipeTagWithForcedTagCreateInput>>;
  /** Delete existing "RecipeTag" nodes from the "Tag.recipeTags" relation. */
  delete?: InputMaybe<Array<RecipeTagWhereUniqueInput>>;
  /** Disconnect existing "RecipeTag" nodes of the "Tag.recipeTags" relation. */
  disconnect?: InputMaybe<Array<RecipeTagWhereUniqueInput>>;
  /** Update existing "RecipeTag" nodes and connect them to the existing "Tag" node, through the "Tag.recipeTags" relation. */
  update?: InputMaybe<Array<TagNestedUpdateRecipeTagsUpdateInput>>;
  /** Upsert existing "RecipeTag" nodes and connect them to the existing "Tag" node, through the "Tag.recipeTags" relation. */
  upsert?: InputMaybe<Array<TagNestedUpsertRecipeTagsUpdateInput>>;
};

export type TagNestedUpdateRecipeTagsUpdateInput = {
  data: RecipeTagWithForcedTagUpdateInput;
  where: RecipeTagWhereUniqueInput;
};

export type RecipeTagWithForcedTagUpdateInput = {
  /** Actions for the "RecipeTag.recipe" relation */
  recipe?: InputMaybe<RecipeTagNestedRecipeUpdateInput>;
};

export type RecipeTagNestedRecipeUpdateInput = {
  /** Connect an existing "Recipe" node to the existing "RecipeTag" node, through the "RecipeTag.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create a new "Recipe" node and connect it to the existing "RecipeTag" node, through the "RecipeTag.recipe" relation. */
  create?: InputMaybe<RecipeCreateInput>;
  /** Disconnect the current connected "Recipe" node, if any, of the "RecipeTag.recipe" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Recipe" node and connect it to the existing "RecipeTag" node, through the "RecipeTag.recipe" relation. */
  update?: InputMaybe<RecipeTagNestedUpdateRecipeUpdateInput>;
  /** Create or update a "Recipe" node and connect it to the existing "RecipeTag" node, through the "RecipeTag.recipe" relation. */
  upsert?: InputMaybe<RecipeTagNestedUpsertRecipeUpdateInput>;
};

export type RecipeTagNestedUpdateRecipeUpdateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeTagNestedUpsertRecipeUpdateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type TagNestedUpsertRecipeTagsUpdateInput = {
  create: RecipeTagWithForcedTagCreateInput;
  update: RecipeTagWithForcedTagUpdateInput;
  where: RecipeTagWhereUniqueInput;
};

export type RecipeTagNestedUpsertTagUpdateInput = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type RecipeNestedUpsertRecipeTagsUpdateInput = {
  create: RecipeTagWithForcedRecipeCreateInput;
  update: RecipeTagWithForcedRecipeUpdateInput;
  where: RecipeTagWhereUniqueInput;
};

export type RecipeNestedRecipeUrlsUpdateInput = {
  /** Connect existing "RecipeUrl" nodes to the existing "Recipe" node, through the "Recipe.recipeUrls" relation. */
  connect?: InputMaybe<Array<RecipeUrlWhereUniqueInput>>;
  /** Create new "RecipeUrl" nodes and connect them to the existing "Recipe" node, through the "Recipe.recipeUrls" relation. */
  create?: InputMaybe<Array<RecipeUrlWithForcedRecipeCreateInput>>;
  /** Delete existing "RecipeUrl" nodes from the "Recipe.recipeUrls" relation. */
  delete?: InputMaybe<Array<RecipeUrlWhereUniqueInput>>;
  /** Disconnect existing "RecipeUrl" nodes of the "Recipe.recipeUrls" relation. */
  disconnect?: InputMaybe<Array<RecipeUrlWhereUniqueInput>>;
  /**
   * Update existing "RecipeUrl" nodes and connect them to the existing "Recipe"
   * node, through the "Recipe.recipeUrls" relation.
   */
  update?: InputMaybe<Array<RecipeNestedUpdateRecipeUrlsUpdateInput>>;
  /**
   * Upsert existing "RecipeUrl" nodes and connect them to the existing "Recipe"
   * node, through the "Recipe.recipeUrls" relation.
   */
  upsert?: InputMaybe<Array<RecipeNestedUpsertRecipeUrlsUpdateInput>>;
};

export type RecipeUrlWithForcedRecipeCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  /** Actions for the "RecipeUrl.url" relation */
  url?: InputMaybe<RecipeUrlNestedUrlCreateInput>;
};

export type RecipeUrlNestedUrlCreateInput = {
  /** Connect an existing "Url" node to the new "RecipeUrl" node, through the "RecipeUrl.url" relation. */
  connect?: InputMaybe<UrlWhereUniqueInput>;
  /** Create a new "Url" node and connect it to the new "RecipeUrl" node, through the "RecipeUrl.url" relation. */
  create?: InputMaybe<UrlCreateInput>;
  /** Update an existing "Url" node and connect it to the new "RecipeUrl" node, through the "RecipeUrl.url" relation. */
  update?: InputMaybe<RecipeUrlNestedUpdateUrlCreateInput>;
  /** Create or update a "Url" node and connect it to the new "RecipeUrl" node, through the "RecipeUrl.url" relation. */
  upsert?: InputMaybe<RecipeUrlNestedUpsertUrlCreateInput>;
};

export type RecipeUrlNestedUpdateUrlCreateInput = {
  data: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};

export type RecipeUrlNestedUpsertUrlCreateInput = {
  create: UrlCreateInput;
  update: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};

export type RecipeNestedUpdateRecipeUrlsUpdateInput = {
  data: RecipeUrlWithForcedRecipeUpdateInput;
  where: RecipeUrlWhereUniqueInput;
};

export type RecipeUrlWithForcedRecipeUpdateInput = {
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "RecipeUrl.url" relation */
  url?: InputMaybe<RecipeUrlNestedUrlUpdateInput>;
};

export type RecipeUrlNestedUrlUpdateInput = {
  /** Connect an existing "Url" node to the existing "RecipeUrl" node, through the "RecipeUrl.url" relation. */
  connect?: InputMaybe<UrlWhereUniqueInput>;
  /** Create a new "Url" node and connect it to the existing "RecipeUrl" node, through the "RecipeUrl.url" relation. */
  create?: InputMaybe<UrlCreateInput>;
  /** Disconnect the current connected "Url" node, if any, of the "RecipeUrl.url" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Url" node and connect it to the existing "RecipeUrl" node, through the "RecipeUrl.url" relation. */
  update?: InputMaybe<RecipeUrlNestedUpdateUrlUpdateInput>;
  /** Create or update a "Url" node and connect it to the existing "RecipeUrl" node, through the "RecipeUrl.url" relation. */
  upsert?: InputMaybe<RecipeUrlNestedUpsertUrlUpdateInput>;
};

export type RecipeUrlNestedUpdateUrlUpdateInput = {
  data: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};

export type RecipeUrlNestedUpsertUrlUpdateInput = {
  create: UrlCreateInput;
  update: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};

export type RecipeNestedUpsertRecipeUrlsUpdateInput = {
  create: RecipeUrlWithForcedRecipeCreateInput;
  update: RecipeUrlWithForcedRecipeUpdateInput;
  where: RecipeUrlWhereUniqueInput;
};

export type RecipeTagNestedUpsertRecipeCreateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeTagNestedUpdateTagCreateInput = {
  data: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type RecipeTagNestedUpsertTagCreateInput = {
  create: TagCreateInput;
  update: TagUpdateInput;
  where: TagWhereUniqueInput;
};

export type RecipeNestedRecipeUrlsCreateInput = {
  /** Connect existing "RecipeUrl" nodes to the new "Recipe" node, through the "Recipe.recipeUrls" relation. */
  connect?: InputMaybe<Array<RecipeUrlWhereUniqueInput>>;
  /** Create new "RecipeUrl" nodes and connect them to the new "Recipe" node, through the "Recipe.recipeUrls" relation. */
  create?: InputMaybe<Array<RecipeUrlWithForcedRecipeCreateInput>>;
};

export type RecipeUrlNestedUpdateRecipeCreateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeUrlNestedUpsertRecipeCreateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type UrlNestedUpdateRecipeUrlsUpdateInput = {
  data: RecipeUrlWithForcedUrlUpdateInput;
  where: RecipeUrlWhereUniqueInput;
};

export type RecipeUrlWithForcedUrlUpdateInput = {
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "RecipeUrl.recipe" relation */
  recipe?: InputMaybe<RecipeUrlNestedRecipeUpdateInput>;
};

export type RecipeUrlNestedRecipeUpdateInput = {
  /** Connect an existing "Recipe" node to the existing "RecipeUrl" node, through the "RecipeUrl.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create a new "Recipe" node and connect it to the existing "RecipeUrl" node, through the "RecipeUrl.recipe" relation. */
  create?: InputMaybe<RecipeCreateInput>;
  /** Disconnect the current connected "Recipe" node, if any, of the "RecipeUrl.recipe" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Recipe" node and connect it to the existing "RecipeUrl" node, through the "RecipeUrl.recipe" relation. */
  update?: InputMaybe<RecipeUrlNestedUpdateRecipeUpdateInput>;
  /** Create or update a "Recipe" node and connect it to the existing "RecipeUrl" node, through the "RecipeUrl.recipe" relation. */
  upsert?: InputMaybe<RecipeUrlNestedUpsertRecipeUpdateInput>;
};

export type RecipeUrlNestedUpdateRecipeUpdateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeUrlNestedUpsertRecipeUpdateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type UrlNestedUpsertRecipeUrlsUpdateInput = {
  create: RecipeUrlWithForcedUrlCreateInput;
  update: RecipeUrlWithForcedUrlUpdateInput;
  where: RecipeUrlWhereUniqueInput;
};

export type CategoryUrlNestedUpsertUrlUpdateInput = {
  create: UrlCreateInput;
  update: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};

export type CategoryNestedUpsertCategoryUrlsUpdateInput = {
  create: CategoryUrlWithForcedCategoryCreateInput;
  update: CategoryUrlWithForcedCategoryUpdateInput;
  where: CategoryUrlWhereUniqueInput;
};

export type CategoryNestedChildrenUpdateInput = {
  /** Connect existing "Category" nodes to the existing "Category" node, through the "Category.children" relation. */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create new "Category" nodes and connect them to the existing "Category" node, through the "Category.children" relation. */
  create?: InputMaybe<Array<CategoryWithForcedParentCreateInput>>;
  /** Delete existing "Category" nodes from the "Category.children" relation. */
  delete?: InputMaybe<Array<CategoryWithForcedParentWhereUniqueInput>>;
  /** Disconnect existing "Category" nodes of the "Category.children" relation. */
  disconnect?: InputMaybe<Array<CategoryWithForcedParentWhereUniqueInput>>;
  /**
   * Update existing "Category" nodes and connect them to the existing "Category"
   * node, through the "Category.children" relation.
   */
  update?: InputMaybe<Array<CategoryNestedUpdateChildrenUpdateInput>>;
  /**
   * Upsert existing "Category" nodes and connect them to the existing "Category"
   * node, through the "Category.children" relation.
   */
  upsert?: InputMaybe<Array<CategoryNestedUpsertChildrenUpdateInput>>;
};

export type CategoryWithForcedParentCreateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  brandKey: Scalars['String']['input'];
  /** Actions for the "Category.categoryUrls" relation: "CategoryUrl.category"'s inverse relation */
  categoryUrls?: InputMaybe<CategoryNestedCategoryUrlsCreateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  left: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
  medias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.recipeCategories" relation: "RecipeCategory.category"'s inverse relation */
  recipeCategories?: InputMaybe<CategoryNestedRecipeCategoriesCreateInput>;
  right: Scalars['Int']['input'];
  rootId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CategoryNestedChildrenCreateInput = {
  /** Connect existing "Category" nodes to the new "Category" node, through the "Category.children" relation. */
  connect?: InputMaybe<Array<CategoryWhereUniqueInput>>;
  /** Create new "Category" nodes and connect them to the new "Category" node, through the "Category.children" relation. */
  create?: InputMaybe<Array<CategoryWithForcedParentCreateInput>>;
};

export type CategoryNestedRecipeCategoriesCreateInput = {
  /** Connect existing "RecipeCategory" nodes to the new "Category" node, through the "Category.recipeCategories" relation. */
  connect?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /**
   * Create new "RecipeCategory" nodes and connect them to the new "Category" node,
   * through the "Category.recipeCategories" relation.
   */
  create?: InputMaybe<Array<RecipeCategoryWithForcedCategoryCreateInput>>;
};

export type RecipeCategoryWithForcedCategoryCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  /** Actions for the "RecipeCategory.recipe" relation */
  recipe?: InputMaybe<RecipeCategoryNestedRecipeCreateInput>;
};

export type RecipeCategoryNestedRecipeCreateInput = {
  /** Connect an existing "Recipe" node to the new "RecipeCategory" node, through the "RecipeCategory.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create a new "Recipe" node and connect it to the new "RecipeCategory" node, through the "RecipeCategory.recipe" relation. */
  create?: InputMaybe<RecipeCreateInput>;
  /**
   * Update an existing "Recipe" node and connect it to the new "RecipeCategory"
   * node, through the "RecipeCategory.recipe" relation.
   */
  update?: InputMaybe<RecipeCategoryNestedUpdateRecipeCreateInput>;
  /**
   * Create or update a "Recipe" node and connect it to the new "RecipeCategory"
   * node, through the "RecipeCategory.recipe" relation.
   */
  upsert?: InputMaybe<RecipeCategoryNestedUpsertRecipeCreateInput>;
};

export type RecipeCategoryNestedUpdateRecipeCreateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeCategoryNestedUpsertRecipeCreateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

/** Given a forced "parent", identifies exactly one "Category" node. */
export type CategoryWithForcedParentWhereUniqueInput = {
  slug: Scalars['String']['input'];
};

export type CategoryNestedUpdateChildrenUpdateInput = {
  data: CategoryWithForcedParentUpdateInput;
  where: CategoryWithOptionalParentWhereUniqueInput;
};

export type CategoryWithForcedParentUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  brandKey?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.categoryUrls" relation: "CategoryUrl.category"'s inverse relation */
  categoryUrls?: InputMaybe<CategoryNestedCategoryUrlsUpdateInput>;
  /** Actions for the "Category.children" relation: "Category.parent"'s inverse relation */
  children?: InputMaybe<CategoryNestedChildrenUpdateInput>;
  left?: InputMaybe<Scalars['Int']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  medias?: InputMaybe<Scalars['String']['input']>;
  /** Actions for the "Category.recipeCategories" relation: "RecipeCategory.category"'s inverse relation */
  recipeCategories?: InputMaybe<CategoryNestedRecipeCategoriesUpdateInput>;
  right?: InputMaybe<Scalars['Int']['input']>;
  rootId?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryNestedRecipeCategoriesUpdateInput = {
  /** Connect existing "RecipeCategory" nodes to the existing "Category" node, through the "Category.recipeCategories" relation. */
  connect?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /**
   * Create new "RecipeCategory" nodes and connect them to the existing "Category"
   * node, through the "Category.recipeCategories" relation.
   */
  create?: InputMaybe<Array<RecipeCategoryWithForcedCategoryCreateInput>>;
  /** Delete existing "RecipeCategory" nodes from the "Category.recipeCategories" relation. */
  delete?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /** Disconnect existing "RecipeCategory" nodes of the "Category.recipeCategories" relation. */
  disconnect?: InputMaybe<Array<RecipeCategoryWhereUniqueInput>>;
  /**
   * Update existing "RecipeCategory" nodes and connect them to the existing
   * "Category" node, through the "Category.recipeCategories" relation.
   */
  update?: InputMaybe<Array<CategoryNestedUpdateRecipeCategoriesUpdateInput>>;
  /**
   * Upsert existing "RecipeCategory" nodes and connect them to the existing
   * "Category" node, through the "Category.recipeCategories" relation.
   */
  upsert?: InputMaybe<Array<CategoryNestedUpsertRecipeCategoriesUpdateInput>>;
};

export type CategoryNestedUpdateRecipeCategoriesUpdateInput = {
  data: RecipeCategoryWithForcedCategoryUpdateInput;
  where: RecipeCategoryWhereUniqueInput;
};

export type RecipeCategoryWithForcedCategoryUpdateInput = {
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "RecipeCategory.recipe" relation */
  recipe?: InputMaybe<RecipeCategoryNestedRecipeUpdateInput>;
};

export type RecipeCategoryNestedRecipeUpdateInput = {
  /** Connect an existing "Recipe" node to the existing "RecipeCategory" node, through the "RecipeCategory.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /**
   * Create a new "Recipe" node and connect it to the existing "RecipeCategory"
   * node, through the "RecipeCategory.recipe" relation.
   */
  create?: InputMaybe<RecipeCreateInput>;
  /** Disconnect the current connected "Recipe" node, if any, of the "RecipeCategory.recipe" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update an existing "Recipe" node and connect it to the existing
   * "RecipeCategory" node, through the "RecipeCategory.recipe" relation.
   */
  update?: InputMaybe<RecipeCategoryNestedUpdateRecipeUpdateInput>;
  /**
   * Create or update a "Recipe" node and connect it to the existing
   * "RecipeCategory" node, through the "RecipeCategory.recipe" relation.
   */
  upsert?: InputMaybe<RecipeCategoryNestedUpsertRecipeUpdateInput>;
};

export type RecipeCategoryNestedUpdateRecipeUpdateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeCategoryNestedUpsertRecipeUpdateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type CategoryNestedUpsertRecipeCategoriesUpdateInput = {
  create: RecipeCategoryWithForcedCategoryCreateInput;
  update: RecipeCategoryWithForcedCategoryUpdateInput;
  where: RecipeCategoryWhereUniqueInput;
};

/**
 * Given a known "parent", identifies exactly one "Category" node with one of these unique combinations of values:
 * - _id
 * - id
 * - parent (optional), slug
 */
export type CategoryWithOptionalParentWhereUniqueInput = {
  _id?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  parent?: InputMaybe<CategoryWhereUniqueInput>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryNestedUpsertChildrenUpdateInput = {
  create: CategoryWithForcedParentCreateInput;
  update: CategoryWithForcedParentUpdateInput;
  where: CategoryWithOptionalParentWhereUniqueInput;
};

export type CategoryNestedParentUpdateInput = {
  /** Connect an existing "Category" node to the existing "Category" node, through the "Category.parent" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Disconnect the current connected "Category" node, if any, of the "Category.parent" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update an existing "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  update?: InputMaybe<CategoryNestedUpdateParentUpdateInput>;
  /** Create or update a "Category" node and connect it to the existing "Category" node, through the "Category.parent" relation. */
  upsert?: InputMaybe<CategoryNestedUpsertParentUpdateInput>;
};

export type CategoryNestedUpdateParentUpdateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpsertParentUpdateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUrlNestedUpsertCategoryCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type UrlNestedRecipeUrlsCreateInput = {
  /** Connect existing "RecipeUrl" nodes to the new "Url" node, through the "Url.recipeUrls" relation. */
  connect?: InputMaybe<Array<RecipeUrlWhereUniqueInput>>;
  /** Create new "RecipeUrl" nodes and connect them to the new "Url" node, through the "Url.recipeUrls" relation. */
  create?: InputMaybe<Array<RecipeUrlWithForcedUrlCreateInput>>;
};

export type CategoryUrlNestedUpdateUrlCreateInput = {
  data: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};

export type CategoryUrlNestedUpsertUrlCreateInput = {
  create: UrlCreateInput;
  update: UrlUpdateInput;
  where: UrlWhereUniqueInput;
};

export type CategoryNestedParentCreateInput = {
  /** Connect an existing "Category" node to the new "Category" node, through the "Category.parent" relation. */
  connect?: InputMaybe<CategoryWhereUniqueInput>;
  /** Create a new "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  create?: InputMaybe<CategoryCreateInput>;
  /** Update an existing "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  update?: InputMaybe<CategoryNestedUpdateParentCreateInput>;
  /** Create or update a "Category" node and connect it to the new "Category" node, through the "Category.parent" relation. */
  upsert?: InputMaybe<CategoryNestedUpsertParentCreateInput>;
};

export type CategoryNestedUpdateParentCreateInput = {
  data: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryNestedUpsertParentCreateInput = {
  create: CategoryCreateInput;
  update: CategoryUpdateInput;
  where: CategoryWhereUniqueInput;
};

export type CategoryUrlCreateInput = {
  /** Actions for the "CategoryUrl.category" relation */
  category?: InputMaybe<CategoryUrlNestedCategoryCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  /** Actions for the "CategoryUrl.url" relation */
  url?: InputMaybe<CategoryUrlNestedUrlCreateInput>;
};

export type FacPublicIdCreateInput = {
  urlId?: InputMaybe<Scalars['ID']['input']>;
};

export type PromptCreateInput = {
  body: Scalars['String']['input'];
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};

export type RecipeCategoryCreateInput = {
  /** Actions for the "RecipeCategory.category" relation */
  category?: InputMaybe<RecipeCategoryNestedCategoryCreateInput>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  /** Actions for the "RecipeCategory.recipe" relation */
  recipe?: InputMaybe<RecipeCategoryNestedRecipeCreateInput>;
};

export type RecipeGuideCreateInput = {
  guideId?: InputMaybe<Scalars['ID']['input']>;
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  /** Actions for the "RecipeGuide.recipe" relation */
  recipe?: InputMaybe<RecipeGuideNestedRecipeCreateInput>;
};

export type RecipeGuideNestedRecipeCreateInput = {
  /** Connect an existing "Recipe" node to the new "RecipeGuide" node, through the "RecipeGuide.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create a new "Recipe" node and connect it to the new "RecipeGuide" node, through the "RecipeGuide.recipe" relation. */
  create?: InputMaybe<RecipeCreateInput>;
  /** Update an existing "Recipe" node and connect it to the new "RecipeGuide" node, through the "RecipeGuide.recipe" relation. */
  update?: InputMaybe<RecipeGuideNestedUpdateRecipeCreateInput>;
  /** Create or update a "Recipe" node and connect it to the new "RecipeGuide" node, through the "RecipeGuide.recipe" relation. */
  upsert?: InputMaybe<RecipeGuideNestedUpsertRecipeCreateInput>;
};

export type RecipeGuideNestedUpdateRecipeCreateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeGuideNestedUpsertRecipeCreateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeHistoryCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "RecipeHistory.recipe" relation */
  recipe: RecipeHistoryNestedRecipeCreateInput;
  status?: InputMaybe<RecipeStatus>;
};

export type RecipeHistoryNestedRecipeCreateInput = {
  /** Connect an existing "Recipe" node to the new "RecipeHistory" node, through the "RecipeHistory.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create a new "Recipe" node and connect it to the new "RecipeHistory" node, through the "RecipeHistory.recipe" relation. */
  create?: InputMaybe<RecipeCreateInput>;
  /**
   * Update an existing "Recipe" node and connect it to the new "RecipeHistory"
   * node, through the "RecipeHistory.recipe" relation.
   */
  update?: InputMaybe<RecipeHistoryNestedUpdateRecipeCreateInput>;
  /**
   * Create or update a "Recipe" node and connect it to the new "RecipeHistory"
   * node, through the "RecipeHistory.recipe" relation.
   */
  upsert?: InputMaybe<RecipeHistoryNestedUpsertRecipeCreateInput>;
};

export type RecipeHistoryNestedUpdateRecipeCreateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeHistoryNestedUpsertRecipeCreateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeTagCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Actions for the "RecipeTag.recipe" relation */
  recipe?: InputMaybe<RecipeTagNestedRecipeCreateInput>;
  /** Actions for the "RecipeTag.tag" relation */
  tag?: InputMaybe<RecipeTagNestedTagCreateInput>;
};

export type RecipeUrlCreateInput = {
  /** The public ID, an UUID v4 */
  id?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  /** Actions for the "RecipeUrl.recipe" relation */
  recipe?: InputMaybe<RecipeUrlNestedRecipeCreateInput>;
  /** Actions for the "RecipeUrl.url" relation */
  url?: InputMaybe<RecipeUrlNestedUrlCreateInput>;
};

export type VoiPublicIdCreateInput = {
  urlId?: InputMaybe<Scalars['ID']['input']>;
};

export type CacPublicIdUpdateInput = {
  urlId?: InputMaybe<Scalars['ID']['input']>;
};

export type CategoryUrlUpdateInput = {
  /** Actions for the "CategoryUrl.category" relation */
  category?: InputMaybe<CategoryUrlNestedCategoryUpdateInput>;
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "CategoryUrl.url" relation */
  url?: InputMaybe<CategoryUrlNestedUrlUpdateInput>;
};

export type FacPublicIdUpdateInput = {
  urlId?: InputMaybe<Scalars['ID']['input']>;
};

export type PromptUpdateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
};

export type RecipeCategoryUpdateInput = {
  /** Actions for the "RecipeCategory.category" relation */
  category?: InputMaybe<RecipeCategoryNestedCategoryUpdateInput>;
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "RecipeCategory.recipe" relation */
  recipe?: InputMaybe<RecipeCategoryNestedRecipeUpdateInput>;
};

export type RecipeGuideUpdateInput = {
  guideId?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "RecipeGuide.recipe" relation */
  recipe?: InputMaybe<RecipeGuideNestedRecipeUpdateInput>;
};

export type RecipeGuideNestedRecipeUpdateInput = {
  /** Connect an existing "Recipe" node to the existing "RecipeGuide" node, through the "RecipeGuide.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /** Create a new "Recipe" node and connect it to the existing "RecipeGuide" node, through the "RecipeGuide.recipe" relation. */
  create?: InputMaybe<RecipeCreateInput>;
  /** Disconnect the current connected "Recipe" node, if any, of the "RecipeGuide.recipe" relation. */
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Update an existing "Recipe" node and connect it to the existing "RecipeGuide"
   * node, through the "RecipeGuide.recipe" relation.
   */
  update?: InputMaybe<RecipeGuideNestedUpdateRecipeUpdateInput>;
  /**
   * Create or update a "Recipe" node and connect it to the existing "RecipeGuide"
   * node, through the "RecipeGuide.recipe" relation.
   */
  upsert?: InputMaybe<RecipeGuideNestedUpsertRecipeUpdateInput>;
};

export type RecipeGuideNestedUpdateRecipeUpdateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeGuideNestedUpsertRecipeUpdateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeHistoryUpdateInput = {
  /** Actions for the "RecipeHistory.recipe" relation */
  recipe?: InputMaybe<RecipeHistoryNestedRecipeUpdateInput>;
  status?: InputMaybe<RecipeStatus>;
};

export type RecipeHistoryNestedRecipeUpdateInput = {
  /** Connect an existing "Recipe" node to the existing "RecipeHistory" node, through the "RecipeHistory.recipe" relation. */
  connect?: InputMaybe<RecipeWhereUniqueInput>;
  /**
   * Create a new "Recipe" node and connect it to the existing "RecipeHistory"
   * node, through the "RecipeHistory.recipe" relation.
   */
  create?: InputMaybe<RecipeCreateInput>;
  /**
   * Update an existing "Recipe" node and connect it to the existing
   * "RecipeHistory" node, through the "RecipeHistory.recipe" relation.
   */
  update?: InputMaybe<RecipeHistoryNestedUpdateRecipeUpdateInput>;
  /**
   * Create or update a "Recipe" node and connect it to the existing
   * "RecipeHistory" node, through the "RecipeHistory.recipe" relation.
   */
  upsert?: InputMaybe<RecipeHistoryNestedUpsertRecipeUpdateInput>;
};

export type RecipeHistoryNestedUpdateRecipeUpdateInput = {
  data: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeHistoryNestedUpsertRecipeUpdateInput = {
  create: RecipeCreateInput;
  update: RecipeUpdateInput;
  where: RecipeWhereUniqueInput;
};

export type RecipeTagUpdateInput = {
  /** Actions for the "RecipeTag.recipe" relation */
  recipe?: InputMaybe<RecipeTagNestedRecipeUpdateInput>;
  /** Actions for the "RecipeTag.tag" relation */
  tag?: InputMaybe<RecipeTagNestedTagUpdateInput>;
};

export type RecipeUrlUpdateInput = {
  position?: InputMaybe<Scalars['Int']['input']>;
  /** Actions for the "RecipeUrl.recipe" relation */
  recipe?: InputMaybe<RecipeUrlNestedRecipeUpdateInput>;
  /** Actions for the "RecipeUrl.url" relation */
  url?: InputMaybe<RecipeUrlNestedUrlUpdateInput>;
};

export type VoiPublicIdUpdateInput = {
  urlId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetVertexAiRecipesQuery_getVertexAIRecipes_vertexAIRecipesResultType_ingredients_vertexAIRecipesIngredientsType = {
  __typename?: 'vertexAIRecipesIngredientsType',
  name: string,
  count: number
};

export type GetVertexAiRecipesQuery_getVertexAIRecipes_vertexAIRecipesResultType = {
  __typename?: 'vertexAIRecipesResultType',
  recipesIds: Array<string>,
  ingredients: Array<GetVertexAiRecipesQuery_getVertexAIRecipes_vertexAIRecipesResultType_ingredients_vertexAIRecipesIngredientsType>
};

export type GetVertexAiRecipesQuery_Query = {
  __typename?: 'Query',
  getVertexAIRecipes?: GetVertexAiRecipesQuery_getVertexAIRecipes_vertexAIRecipesResultType | null
};


export type GetVertexAiRecipesQueryVariables = Exact<{
  excludedIngredients?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  recipeNumber: Scalars['Int']['input'];
  query: Scalars['String']['input'];
  brandKey: BrandKey;
}>;


export type GetVertexAiRecipesQuery = GetVertexAiRecipesQuery_Query;

export type GetRecipesQuery_recipes_Recipe_recipeUrls_RecipeUrl_url_Url = {
  __typename?: 'Url',
  path: string
};

export type GetRecipesQuery_recipes_Recipe_recipeUrls_RecipeUrl = {
  __typename?: 'RecipeUrl',
  url?: GetRecipesQuery_recipes_Recipe_recipeUrls_RecipeUrl_url_Url | null
};

export type GetRecipesQuery_recipes_Recipe_recipeCategories_RecipeCategory_category_Category = {
  __typename?: 'Category',
  id: string,
  title: string
};

export type GetRecipesQuery_recipes_Recipe_recipeCategories_RecipeCategory = {
  __typename?: 'RecipeCategory',
  category?: GetRecipesQuery_recipes_Recipe_recipeCategories_RecipeCategory_category_Category | null
};

export type GetRecipesQuery_recipes_Recipe = {
  __typename?: 'Recipe',
  brandKey: string,
  createdAt: string,
  id: string,
  medias?: string | null,
  publishedAt?: string | null,
  status?: RecipeStatus | null,
  title: string,
  authorName?: string | null,
  recipeUrls: Array<GetRecipesQuery_recipes_Recipe_recipeUrls_RecipeUrl>,
  recipeCategories: Array<GetRecipesQuery_recipes_Recipe_recipeCategories_RecipeCategory>
};

export type GetRecipesQuery_Query = {
  __typename?: 'Query',
  recipes: Array<GetRecipesQuery_recipes_Recipe>
};


export type GetRecipesQueryVariables = Exact<{
  where?: InputMaybe<RecipeWhereInput>;
  orderBy?: InputMaybe<Array<RecipeOrderByInput> | RecipeOrderByInput>;
  first: Scalars['Int']['input'];
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRecipesQuery = GetRecipesQuery_Query;

export type RecipeCountQuery_Query = {
  __typename?: 'Query',
  recipeCount: number
};


export type RecipeCountQueryVariables = Exact<{
  where?: InputMaybe<RecipeWhereInput>;
}>;


export type RecipeCountQuery = RecipeCountQuery_Query;


export const GetVertexAiRecipesDocument = gql`
    query GetVertexAIRecipes($excludedIngredients: [String!], $recipeNumber: Int!, $query: String!, $brandKey: BrandKey!) {
  getVertexAIRecipes(excludedIngredients: $excludedIngredients, recipeNumber: $recipeNumber, query: $query, brandKey: $brandKey) {
    recipesIds
    ingredients {
      name
      count
    }
  }
}
    `;

/**
 * __useGetVertexAiRecipesQuery__
 *
 * To run a query within a React component, call `useGetVertexAiRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVertexAiRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVertexAiRecipesQuery({
 *   variables: {
 *      excludedIngredients: // value for 'excludedIngredients'
 *      recipeNumber: // value for 'recipeNumber'
 *      query: // value for 'query'
 *      brandKey: // value for 'brandKey'
 *   },
 * });
 */
export function useGetVertexAiRecipesQuery(baseOptions: Apollo.QueryHookOptions<GetVertexAiRecipesQuery, GetVertexAiRecipesQueryVariables> & ({ variables: GetVertexAiRecipesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVertexAiRecipesQuery, GetVertexAiRecipesQueryVariables>(GetVertexAiRecipesDocument, options);
      }
export function useGetVertexAiRecipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVertexAiRecipesQuery, GetVertexAiRecipesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVertexAiRecipesQuery, GetVertexAiRecipesQueryVariables>(GetVertexAiRecipesDocument, options);
        }
export function useGetVertexAiRecipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVertexAiRecipesQuery, GetVertexAiRecipesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVertexAiRecipesQuery, GetVertexAiRecipesQueryVariables>(GetVertexAiRecipesDocument, options);
        }
export type GetVertexAiRecipesQueryHookResult = ReturnType<typeof useGetVertexAiRecipesQuery>;
export type GetVertexAiRecipesLazyQueryHookResult = ReturnType<typeof useGetVertexAiRecipesLazyQuery>;
export type GetVertexAiRecipesSuspenseQueryHookResult = ReturnType<typeof useGetVertexAiRecipesSuspenseQuery>;
export type GetVertexAiRecipesQueryResult = Apollo.QueryResult<GetVertexAiRecipesQuery, GetVertexAiRecipesQueryVariables>;
export const GetRecipesDocument = gql`
    query GetRecipes($where: RecipeWhereInput, $orderBy: [RecipeOrderByInput!], $first: Int!, $skip: Int) {
  recipes(first: $first, where: $where, skip: $skip, orderBy: $orderBy) {
    brandKey
    createdAt
    id
    medias
    recipeUrls(first: 1, orderBy: position_ASC) {
      url {
        path
      }
    }
    publishedAt
    status
    title
    recipeCategories(first: 10, orderBy: position_ASC) {
      category {
        id
        title
      }
    }
    authorName
  }
}
    `;

/**
 * __useGetRecipesQuery__
 *
 * To run a query within a React component, call `useGetRecipesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecipesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecipesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useGetRecipesQuery(baseOptions: Apollo.QueryHookOptions<GetRecipesQuery, GetRecipesQueryVariables> & ({ variables: GetRecipesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecipesQuery, GetRecipesQueryVariables>(GetRecipesDocument, options);
      }
export function useGetRecipesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecipesQuery, GetRecipesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecipesQuery, GetRecipesQueryVariables>(GetRecipesDocument, options);
        }
export function useGetRecipesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRecipesQuery, GetRecipesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRecipesQuery, GetRecipesQueryVariables>(GetRecipesDocument, options);
        }
export type GetRecipesQueryHookResult = ReturnType<typeof useGetRecipesQuery>;
export type GetRecipesLazyQueryHookResult = ReturnType<typeof useGetRecipesLazyQuery>;
export type GetRecipesSuspenseQueryHookResult = ReturnType<typeof useGetRecipesSuspenseQuery>;
export type GetRecipesQueryResult = Apollo.QueryResult<GetRecipesQuery, GetRecipesQueryVariables>;
export const RecipeCountDocument = gql`
    query RecipeCount($where: RecipeWhereInput) {
  recipeCount(where: $where)
}
    `;

/**
 * __useRecipeCountQuery__
 *
 * To run a query within a React component, call `useRecipeCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipeCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipeCountQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRecipeCountQuery(baseOptions?: Apollo.QueryHookOptions<RecipeCountQuery, RecipeCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecipeCountQuery, RecipeCountQueryVariables>(RecipeCountDocument, options);
      }
export function useRecipeCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecipeCountQuery, RecipeCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecipeCountQuery, RecipeCountQueryVariables>(RecipeCountDocument, options);
        }
export function useRecipeCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecipeCountQuery, RecipeCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecipeCountQuery, RecipeCountQueryVariables>(RecipeCountDocument, options);
        }
export type RecipeCountQueryHookResult = ReturnType<typeof useRecipeCountQuery>;
export type RecipeCountLazyQueryHookResult = ReturnType<typeof useRecipeCountLazyQuery>;
export type RecipeCountSuspenseQueryHookResult = ReturnType<typeof useRecipeCountSuspenseQuery>;
export type RecipeCountQueryResult = Apollo.QueryResult<RecipeCountQuery, RecipeCountQueryVariables>;